import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import Spreadsheet from 'react-spreadsheet';
import styled from 'styled-components';
import {useParentState} from 'utils';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
const MyModal =styled(Modal)`
  .ant-modal-body {
  display: flex;
  flex-direction: column;
  // align-content: center;
  align-items: center;
}
`;

const columns = ['key',"group","en","fr"]
export const keywords = [
    {
        "key": "lng",
        "group": "language",
        "en": "Français",
        "fr": "English"
    },
    {
        "key": "lngshort",
        "group": "language",
        "en": "EN",
        "fr": "FR"
    },
    {
        "key": "title",
        "group": "app",
        "en": "Port Emissions Inventory Tool",
        "fr": "Outil d'inventaire des émissions portuaires"
    },
    {
        "key": "stitle",
        "group": "app",
        "en": "PEIT",
        "fr": "OIÉP"
    },
    {
        "key": "about",
        "group": "app",
        "en": "About",
        "fr": "À propos"
    },
    {
        "key": "created",
        "group": "app",
        "en": "©2025 Government of Canada",
        "fr": "©2025 Gouvernement du Canada"
    },
    {
        "key": "side-emissions",
        "group": "app",
        "en": "Emissions",
        "fr": "Émissions"
    },
    {
        "key": "nodatalist",
        "group": "app",
        "en": "There are no port emissions inventory activity questionnaires currently available. You can create a new questionnaire by clicking the 'Create Now'.",
        "fr": "Il n’existe à l’heure actuelle aucun questionnaire sur les activités dans l’inventaire des émissions portuaires. Vous pouvez créer un nouveau questionnaire en cliquant sur « Créer maintenant »."
    },
    {
        "key": "importlist",
        "group": "app",
        "en": "Import List",
        "fr": "Importez la liste"
    },
    {
        "key": "exportlist",
        "group": "app",
        "en": "Export List",
        "fr": "Exportez la liste"
    },
    {
        "key": "createnow",
        "group": "app",
        "en": "Create Now",
        "fr": "Créer maintenant"
    },
    {
        "key": "new",
        "group": "app",
        "en": "New",
        "fr": "Nouveau"
    },
    {
        "key": "name",
        "group": "app",
        "en": "Name",
        "fr": "Nom"
    },
    {
        "key": "isSave",
        "group": "app",
        "en": "Compute",
        "fr": "Calculer"
    },
    {
        "key": "name",
        "group": "app",
        "en": "Name",
        "fr": "Nom"
    },
    {
        "key": "edit",
        "group": "app",
        "en": "Edit",
        "fr": "Modifier"
    },
    {
        "key": "input",
        "group": "app",
        "en": "Input",
        "fr": "Entrée"
    },
    {
        "key": "output",
        "group": "app",
        "en": "Output",
        "fr": "Résultats"
    },
    {
        "key": "introduction",
        "group": "app",
        "en": "Introduction",
        "fr": "Introduction"
    },
    {
        "key": "terminal",
        "group": "app",
        "en": "Terminal",
        "fr": "Terminal"
    },
    {
        "key": "admin",
        "group": "app",
        "en": "Admin",
        "fr": "Admin"
    },
    {
        "key": "marine",
        "group": "app",
        "en": "Marine",
        "fr": "Transport maritime"
    },
    {
        "key": "che",
        "group": "app",
        "en": "CHE",
        "fr": "EMF"
    },
    {
        "key": "road",
        "group": "app",
        "en": "Onroad",
        "fr": "Transport routier"
    },
    {
        "key": "rail",
        "group": "app",
        "en": "Rail",
        "fr": "Transport ferroviaire"
    },
    {
        "key": "tables",
        "group": "app",
        "en": "External Data",
        "fr": "Données externes"
    },
    {
        "key": "newlabel",
        "group": "app",
        "en": "New",
        "fr": "Nouveau"
    },
    {
        "key": "newtitle",
        "group": "app",
        "en": "Create a New Port Emissions Inventory Activity",
        "fr": "Créer une nouvelle activité dans l’inventaire des émissions des ports."
    },
    {
        "key": "newmessage",
        "group": "app",
        "en": "Initiate the creation of a brand new questionnaire for your port emissions inventory activities. Fill out the form with the necessary information and details to customize your questionnaire according to your specific needs",
        "fr": "Lancer la création d’un tout nouveau questionnaire pour vos activités d’inventaire des émissions des ports. Remplissez le formulaire avec les renseignements et les détails nécessaires pour personnaliser votre questionnaire en fonction de vos besoins précis."
    },
    {
        "key": "importlabel",
        "group": "app",
        "en": "Import File",
        "fr": "Importer un fichier"
    },
    {
        "key": "importtitle",
        "group": "app",
        "en": "Import Data from Excel for Quick Setup",
        "fr": "Importer des données d’Excel pour une élaboration rapide"
    },
    {
        "key": "importmessage",
        "group": "app",
        "en": "Jumpstart your questionnaire creation process. Upload an Excel file or JSON file containing your data, and our system will automatically generate the questionnaire fields based on the imported data. This saves you time and effort in setting up your questionnaire. Support for .xlsx and .json files.",
        "fr": "Accélérez le processus de création de votre questionnaire. Téléversez un fichier Excel ou un fichier JSON contenant vos données, et notre système générera automatiquement les champs du questionnaire en fonction des données importées. Vous économiserez ainsi du temps et des efforts pour élaborer votre questionnaire. Soutien pour les fichiers .xlsx et .json."
    },
    {
        "key": "downloadexcel",
        "group": "app",
        "en": "Click here to download excel template.",
        "fr": "Cliquez ici pour télécharger le modèle Excel."
    },
    {
        "key": "uploadmessage",
        "group": "app",
        "en": "Click or drag file to this area to upload to application",
        "fr": "Cliquez ou glissez le fichier dans cette zone pour le téléverser dans l'application"
    },
    {
        "key": "importjson",
        "group": "app",
        "en": "Import .json",
        "fr": "Importer .json"
    },
    {
        "key": "exportjson",
        "group": "app",
        "en": "Export .json",
        "fr": "Exporter .json"
    },
    {
        "key": "excelsheet",
        "group": "app",
        "en": "You can copy data directly from Excel and paste it into the table below.",
        "fr": "Vous pouvez copier les données directement depuis Excel et les coller dans le tableau ci-dessous."
    },
    {
        "key": "nodata",
        "group": "app",
        "en": "No data",
        "fr": "Aucune donnée"
    },
    {
        "key": "import",
        "group": "app",
        "en": "Import",
        "fr": "Importer"
    },
    {
        "key": "add",
        "group": "app",
        "en": "Add",
        "fr": "Ajouter"
    },
    {
        "key": "columns",
        "group": "app",
        "en": "Columns",
        "fr": "Colonnes"
    },
    {
        "key": "description",
        "group": "app",
        "en": "Description",
        "fr": "Description"
    },
    {
        "key": "options",
        "group": "app",
        "en": "Options",
        "fr": "Options"
    },
    {
        "key": "required",
        "group": "app",
        "en": "Required",
        "fr": "Requis"
    },
    {
        "key": "submitted",
        "group": "app",
        "en": "...Submitted for processing...",
        "fr": "...Soumis pour traitement..."
    },
    {
        "key": "processing",
        "group": "app",
        "en": "...processing...",
        "fr": "...traitement en cours..."
    },
    {
        "key": "download",
        "group": "app",
        "en": "Download",
        "fr": "Télécharger"
    },
    {
        "key": "downloadtooltip",
        "group": "app",
        "en": "Download Excel File",
        "fr": "Télécharger le fichier Excel"
    },
    {
        "key": "remove",
        "group": "app",
        "en": "Remove",
        "fr": "Retirer"
    },
    {
        "key": "defaultfile",
        "group": "app",
        "en": "Default File",
        "fr": "Fichier par défaut"
    },
    {
        "key": "customfile",
        "group": "app",
        "en": "Custom File",
        "fr": "Fichier personnalisé"
    },
    {
        "key": "data",
        "group": "app",
        "en": "Data",
        "fr": "Données"
    },
    {
        "key": "notes",
        "group": "app",
        "en": "Notes/comments",
        "fr": "Remarques/commentaires"
    },
    {
        "key": "BTU",
        "group": "units",
        "en": "British Thermal Unit (BTU)",
        "fr": "unité thermique britannique (BTU)"
    },
    {
        "key": "Cfoot",
        "group": "units",
        "en": "cubic feet (ft^3)",
        "fr": "pied cube (pi^3)"
    },
    {
        "key": "Cmetr",
        "group": "units",
        "en": "cubic metre (m^3)",
        "fr": "mètre cube (m^3)"
    },
    {
        "key": "g",
        "group": "units",
        "en": "gram (g)",
        "fr": "gramme (g)"
    },
    {
        "key": "galIM",
        "group": "units",
        "en": "gallon-Imperial",
        "fr": "gallon impérial (gal imp)"
    },
    {
        "key": "galUS",
        "group": "units",
        "en": "gallon-US (US. gal.)",
        "fr": "gallon états-unien (gal US)"
    },
    {
        "key": "GJ",
        "group": "units",
        "en": "gigajoule (GJ)",
        "fr": "gigajoule (GJ)"
    },
    {
        "key": "hphr",
        "group": "units",
        "en": "horsepower hour",
        "fr": "horsepower-heure"
    },
    {
        "key": "kg",
        "group": "units",
        "en": "kilogram (kg)",
        "fr": "kilogramme (kg)"
    },
    {
        "key": "klit",
        "group": "units",
        "en": "kilolitre (kL)",
        "fr": "kilolitre (kL)"
    },
    {
        "key": "KWH",
        "group": "units",
        "en": "kilowatt-hour (kWh)",
        "fr": "kilowatt-heure (kWh)"
    },
    {
        "key": "lbs",
        "group": "units",
        "en": "pounds-US (lb)",
        "fr": "livres (lb)"
    },
    {
        "key": "lit",
        "group": "units",
        "en": "litre (L)",
        "fr": "litre (L)"
    },
    {
        "key": "MJ",
        "group": "units",
        "en": "megajoule (MJ)",
        "fr": "mégajoule (MJ)"
    },
    {
        "key": "MWH",
        "group": "units",
        "en": "megawatt-hour (MWh)",
        "fr": "mégawatt-heure (MWh)"
    },
    {
        "key": "ton",
        "group": "units",
        "en": "tonne (t)",
        "fr": "tonne (t)"
    },
    {
        "key": "hp",
        "group": "units",
        "en": "horsepower (hp)",
        "fr": "horsepower (hp)"
    },
    {
        "key": "kw",
        "group": "units",
        "en": "kilowatt (kW)",
        "fr": "kilowatt (kW)"
    },
    {
        "key": "BTU/h",
        "group": "units",
        "en": "British Thermal Unit per hour (BTU/h)",
        "fr": "unité thermique britannique par heure (BTU/h)"
    },
    {
        "key": "ton",
        "group": "unitsTerminal",
        "en": "tonne (t)",
        "fr": "tonne (t)"
    },
    {
        "key": "teu",
        "group": "unitsTerminal",
        "en": "TEU",
        "fr": "EVP"
    },
    {
        "key": "lit",
        "group": "unitsTerminal",
        "en": "litre (L)",
        "fr": "litre (L)"
    },
    {
        "key": "per",
        "group": "unitsTerminal",
        "en": "person",
        "fr": "personne"
    },
    {
        "key": "bf",
        "group": "unitsTerminal",
        "en": "board feet",
        "fr": "pied-planche"
    },
    {
        "key": "mbf",
        "group": "unitsTerminal",
        "en": "mega board feet",
        "fr": "méga pied-planche"
    },
    {
        "key": "uni",
        "group": "unitsTerminal",
        "en": "units",
        "fr": "unités"
    },
    {
        "key": "Avg",
        "group": "intensity",
        "en": "3 - Medium (average)",
        "fr": "3 - Moyenne"
    },
    {
        "key": "Havg",
        "group": "intensity",
        "en": "4 - Medium/high",
        "fr": "4 - Moyenne/élevée"
    },
    {
        "key": "Hvy",
        "group": "intensity",
        "en": "5 - High",
        "fr": "5 - Élevée"
    },
    {
        "key": "Lavg",
        "group": "intensity",
        "en": "2 - Low/medium",
        "fr": "2 - Faible/moyenne"
    },
    {
        "key": "Light",
        "group": "intensity",
        "en": "1 - Low",
        "fr": "1 - Faible"
    },
    {
        "key": "NULL",
        "group": "intensity",
        "en": "No usage",
        "fr": "Pas d’usage"
    },
    {
        "key": "Bus",
        "group": "fleet",
        "en": "Transit bus",
        "fr": "Autobus urbain"
    },
    {
        "key": "Car",
        "group": "fleet",
        "en": "Passenger car",
        "fr": "Voiture de tourisme"
    },
    {
        "key": "H-Car",
        "group": "fleet",
        "en": "Hybrid passenger car",
        "fr": "Voiture de tourisme hybride"
    },
    {
        "key": "HDV",
        "group": "fleet",
        "en": "Combination truck (tractor-trailer)",
        "fr": "Camion semi-remorque"
    },
    {
        "key": "H-LDV",
        "group": "fleet",
        "en": "Hybrid light commercial truck",
        "fr": "Camion utilitaire léger hybride"
    },
    {
        "key": "H-Tru",
        "group": "fleet",
        "en": "Hybrid passenger truck",
        "fr": "Camion léger hybride"
    },
    {
        "key": "LDV",
        "group": "fleet",
        "en": "Light commercial truck",
        "fr": "Camion utilitaire léger"
    },
    {
        "key": "MDV",
        "group": "fleet",
        "en": "Single unit truck",
        "fr": "Camion non articulé"
    },
    {
        "key": "Truck",
        "group": "fleet",
        "en": "Passenger truck",
        "fr": "Camion léger"
    },
    {
        "key": "Avg",
        "group": "ageProfile",
        "en": "Average/ not known",
        "fr": "moyenne / inconnue"
    },
    {
        "key": "Fleet",
        "group": "ageProfile",
        "en": "Average / not known",
        "fr": "moyenne / inconnue"
    },
    {
        "key": "100414",
        "group": "Substances",
        "en": "Ethyl Benzene",
        "fr": "éthylbenzène"
    },
    {
        "key": "100425",
        "group": "Substances",
        "en": "Styrene",
        "fr": "Styrène"
    },
    {
        "key": "108883",
        "group": "Substances",
        "en": "Toluene",
        "fr": "Toluène"
    },
    {
        "key": "110543",
        "group": "Substances",
        "en": "Hexane",
        "fr": "Hexane"
    },
    {
        "key": "120127",
        "group": "Substances",
        "en": "Anthracene",
        "fr": "Anthracène"
    },
    {
        "key": "129000",
        "group": "Substances",
        "en": "Pyrene",
        "fr": "Pyrène"
    },
    {
        "key": "1330207",
        "group": "Substances",
        "en": "Xylene",
        "fr": "Xylène"
    },
    {
        "key": "16065831",
        "group": "Substances",
        "en": "Chromium (Cr3+)",
        "fr": "Chrome (Cr3+)"
    },
    {
        "key": "18540299",
        "group": "Substances",
        "en": "Chromium (Cr6+)",
        "fr": "Chrome (Cr6+)"
    },
    {
        "key": "191242",
        "group": "Substances",
        "en": "Benzo(g,h,i)perylene",
        "fr": "Benzo(g,h,i)pérylène"
    },
    {
        "key": "193395",
        "group": "Substances",
        "en": "Indeno(1,2,3,c,d)pyrene",
        "fr": "Indéno(1,2,3,c,d)pyrène"
    },
    {
        "key": "200",
        "group": "Substances",
        "en": "Mercury (elemental gaseous)",
        "fr": "Mercure (élémentaire gazeux)"
    },
    {
        "key": "201",
        "group": "Substances",
        "en": "Mercury (divalent gaseous)",
        "fr": "Mercure (divalent gazeux)"
    },
    {
        "key": "202",
        "group": "Substances",
        "en": "Mercury (particulate)",
        "fr": "Mercure (particule)"
    },
    {
        "key": "205992",
        "group": "Substances",
        "en": "Benzo(b)fluoranthene",
        "fr": "Benzo(b)fluoranthène"
    },
    {
        "key": "206440",
        "group": "Substances",
        "en": "Fluoranthene",
        "fr": "Fluoranthène"
    },
    {
        "key": "207089",
        "group": "Substances",
        "en": "Benzo(k)fluoranthene",
        "fr": "Benzo(k)fluoranthène"
    },
    {
        "key": "208968",
        "group": "Substances",
        "en": "Acenaphthylene",
        "fr": "Acenaphthylène"
    },
    {
        "key": "218019",
        "group": "Substances",
        "en": "Chrysene",
        "fr": "Chrysène"
    },
    {
        "key": "50328",
        "group": "Substances",
        "en": "Benzo(a)pyrene",
        "fr": "Benzo(a)pyrène"
    },
    {
        "key": "540841",
        "group": "Substances",
        "en": "2,2,4-Trimethylpentane",
        "fr": "2,2,4-Trimethylpentane"
    },
    {
        "key": "56553",
        "group": "Substances",
        "en": "Benz(a)anthracene",
        "fr": "Benz(a)anthracène"
    },
    {
        "key": "7439921",
        "group": "Substances",
        "en": "Lead",
        "fr": "Plomb"
    },
    {
        "key": "7439965",
        "group": "Substances",
        "en": "Manganese",
        "fr": "Manganèse"
    },
    {
        "key": "7440020",
        "group": "Substances",
        "en": "Nickel",
        "fr": "Nickel"
    },
    {
        "key": "83329",
        "group": "Substances",
        "en": "Acenaphthene",
        "fr": "Acénaphthène"
    },
    {
        "key": "85018",
        "group": "Substances",
        "en": "Phenanthrene",
        "fr": "Phenanthrène"
    },
    {
        "key": "86737",
        "group": "Substances",
        "en": "Fluorene",
        "fr": "Fluorène"
    },
    {
        "key": "91203",
        "group": "Substances",
        "en": "Naphthalene",
        "fr": "Naphthalène"
    },
    {
        "key": "93",
        "group": "Substances",
        "en": "Arsenic & compounds",
        "fr": "Arsenic & composés"
    },
    {
        "key": "ACETA",
        "group": "Substances",
        "en": "Acetaldehyde",
        "fr": "Acétaldéhyde"
    },
    {
        "key": "ACRO",
        "group": "Substances",
        "en": "Acrolein",
        "fr": "Acroléine"
    },
    {
        "key": "BC",
        "group": "Substances",
        "en": "Black Carbon",
        "fr": "Carbone noir"
    },
    {
        "key": "Benzene",
        "group": "Substances",
        "en": "Benzene",
        "fr": "Benzène"
    },
    {
        "key": "CH4",
        "group": "Substances",
        "en": "Methane",
        "fr": "Méthane"
    },
    {
        "key": "CH4_BIO",
        "group": "Substances",
        "en": "Methane (Bio)",
        "fr": "Méthane (Bio)"
    },
    {
        "key": "CO",
        "group": "Substances",
        "en": "Carbon Monoxide",
        "fr": "Oxyde de carbone"
    },
    {
        "key": "CO2",
        "group": "Substances",
        "en": "Carbon Dioxide",
        "fr": "Dioxyde de carbone"
    },
    {
        "key": "CO2_BIO",
        "group": "Substances",
        "en": "Carbon Dioxide (Bio)",
        "fr": "Dioxyde de carbone (Bio)"
    },
    {
        "key": "CO2e",
        "group": "Substances",
        "en": "CO2 equivalent",
        "fr": "Équivalent de CO2"
    },
    {
        "key": "CO2e_BIO",
        "group": "Substances",
        "en": "CO2 equivalent (Bio)",
        "fr": "Équivalent de CO2 (Bio)"
    },
    {
        "key": "DPM",
        "group": "Substances",
        "en": "Diesel Particulate Matter",
        "fr": "Matière particulaire diesel"
    },
    {
        "key": "Ecarb",
        "group": "Substances",
        "en": "Elemental Carbon",
        "fr": "Carbone élémentaire"
    },
    {
        "key": "EquipCnt",
        "group": "Substances",
        "en": "Equipment Count",
        "fr": "Équipement - compte"
    },
    {
        "key": "FORMLD",
        "group": "Substances",
        "en": "Formaldehyde",
        "fr": "Formaldéhyde"
    },
    {
        "key": "Fuel_GJ",
        "group": "Substances",
        "en": "Fuel Used (GJ)",
        "fr": "Carburant utilisé (GJ)"
    },
    {
        "key": "Fuel_L",
        "group": "Substances",
        "en": "Fuel Used (Litre)",
        "fr": "Carburant utilisé (litre)"
    },
    {
        "key": "Fuel_mass",
        "group": "Substances",
        "en": "Fuel Used",
        "fr": "Carburant utilisé"
    },
    {
        "key": "Fuel_MDL_GJ",
        "group": "Substances",
        "en": "Model Fuel Estimate (GJ)",
        "fr": "Carburant estimé par le modèle (GJ)"
    },
    {
        "key": "Fuel_MDL_L",
        "group": "Substances",
        "en": "Model Fuel Estimate (L)",
        "fr": "Carburant estimé par le modèle (L)"
    },
    {
        "key": "Fuel_MDL_mass",
        "group": "Substances",
        "en": "Model Fuel Estimate",
        "fr": "Carburant estimé par le modèle"
    },
    {
        "key": "Hours",
        "group": "Substances",
        "en": "Hours",
        "fr": "Heures"
    },
    {
        "key": "Hrs_Model",
        "group": "Substances",
        "en": "Model Hours",
        "fr": "Heures modèle"
    },
    {
        "key": "Hrs_Report",
        "group": "Substances",
        "en": "Reported Hours",
        "fr": "Heures rapportées"
    },
    {
        "key": "KM",
        "group": "Substances",
        "en": "Distance",
        "fr": "Distance"
    },
    {
        "key": "N2O",
        "group": "Substances",
        "en": "Nitrous oxide",
        "fr": "Oxyde de diazote"
    },
    {
        "key": "N2O_BIO",
        "group": "Substances",
        "en": "Nitrous oxide (Bio)",
        "fr": "Oxyde de diazote (Bio)"
    },
    {
        "key": "NH3",
        "group": "Substances",
        "en": "Ammonia",
        "fr": "Ammoniaque"
    },
    {
        "key": "NOx",
        "group": "Substances",
        "en": "Nitrogen Oxides",
        "fr": "Oxydes d'azote"
    },
    {
        "key": "Ocarb",
        "group": "Substances",
        "en": "Organic Carbon",
        "fr": "Carbone organique"
    },
    {
        "key": "PM",
        "group": "Substances",
        "en": "Primary Total Particulate Matter",
        "fr": "Particules totales primaires"
    },
    {
        "key": "PM10",
        "group": "Substances",
        "en": "Primary PM10 (Filterable and Condensable)",
        "fr": "MP10 primaires (filtrable et condensable)"
    },
    {
        "key": "PM25",
        "group": "Substances",
        "en": "Primary PM2.5 (Filterable and Condensable)",
        "fr": "MP2,5 primaires (filtrable et condensable)"
    },
    {
        "key": "PM25_exhaust",
        "group": "Substances",
        "en": "Diesel Particulate Matter",
        "fr": "Matière particulaire diesel"
    },
    {
        "key": "SO2",
        "group": "Substances",
        "en": "Sulfur Dioxide",
        "fr": "Dioxyde de soufre"
    },
    {
        "key": "SOx",
        "group": "Substances",
        "en": "Sulphur Oxides",
        "fr": "Oxydes de soufre"
    },
    {
        "key": "SUL",
        "group": "Substances",
        "en": "Sulphates",
        "fr": "Sulfates"
    },
    {
        "key": "THC",
        "group": "Substances",
        "en": "Total Hydrocarbons",
        "fr": "Hydrocarbures totaux"
    },
    {
        "key": "VOC",
        "group": "Substances",
        "en": "Volatile Organic Compounds",
        "fr": "Composés organiques volatils"
    },
    {
        "key": "AB",
        "group": "region",
        "en": "Alberta",
        "fr": "Alberta"
    },
    {
        "key": "BC",
        "group": "region",
        "en": "British Columbia",
        "fr": "Colombie-Britannique"
    },
    {
        "key": "MB",
        "group": "region",
        "en": "Manitoba",
        "fr": "Manitoba"
    },
    {
        "key": "NB",
        "group": "region",
        "en": "New Brunswick",
        "fr": "Nouveau-Brunswick"
    },
    {
        "key": "NL",
        "group": "region",
        "en": "Newfoundland and Labrador",
        "fr": "Terre-Neuve et Labrador"
    },
    {
        "key": "NS",
        "group": "region",
        "en": "Nova Scotia",
        "fr": "Nouvelle-Écosse"
    },
    {
        "key": "NT",
        "group": "region",
        "en": "Northwest Territories",
        "fr": "Territoires du Nord-Ouest"
    },
    {
        "key": "NU",
        "group": "region",
        "en": "Nunavut",
        "fr": "Nunavut"
    },
    {
        "key": "ON",
        "group": "region",
        "en": "Ontario",
        "fr": "Ontario"
    },
    {
        "key": "PE",
        "group": "region",
        "en": "Prince Edward Island",
        "fr": "Île-du-Prince-Édouard"
    },
    {
        "key": "QC",
        "group": "region",
        "en": "Quebec",
        "fr": "Québec"
    },
    {
        "key": "SK",
        "group": "region",
        "en": "Saskatchewan",
        "fr": "Saskatchewan"
    },
    {
        "key": "YT",
        "group": "region",
        "en": "Yukon",
        "fr": "Yukon"
    },
    {
        "key": "ALL",
        "group": "region",
        "en": "All regions",
        "fr": "Toutes les régions"
    },
    {
        "key": "O",
        "group": "region",
        "en": "Other",
        "fr": "Autre"
    },
    {
        "key": "Dies",
        "group": "fuelTypeCHE",
        "en": "Diesel",
        "fr": "Diesel"
    },
    {
        "key": "B100",
        "group": "fuelTypeCHE",
        "en": "B100 (100% biodiesel)",
        "fr": "B100 (100% biodiesel)"
    },
    {
        "key": "BBL",
        "group": "fuelTypeCHE",
        "en": "Biodiesel blend",
        "fr": "Mélange biodiesel"
    },
    {
        "key": "Gas",
        "group": "fuelTypeCHE",
        "en": "Gasoline",
        "fr": "Essence"
    },
    {
        "key": "EBL",
        "group": "fuelTypeCHE",
        "en": "Gasoline/ethanol blend",
        "fr": "Essence/mélange éthanol"
    },
    {
        "key": "Prop",
        "group": "fuelTypeCHE",
        "en": "Propane (LPG)",
        "fr": "Propane (GPL)"
    },
    {
        "key": "NatG",
        "group": "fuelTypeCHE",
        "en": "Natural Gas",
        "fr": "Gaz naturel"
    },
    {
        "key": "Elec",
        "group": "fuelTypeCHE",
        "en": "Electricity",
        "fr": "Électricité"
    },
    {
        "key": "Gas2",
        "group": "fuelTypeCHE",
        "en": "2-Stroke Mix Gasoline",
        "fr": "Mélange essence pour moteur à deux temps"
    },
    {
        "key": "Dies",
        "group": "fuelTypeHighwayVeh",
        "en": "Diesel",
        "fr": "Diesel"
    },
    {
        "key": "Gas",
        "group": "fuelTypeHighwayVeh",
        "en": "Gasoline",
        "fr": "Essence"
    },
    {
        "key": "Elec",
        "group": "fuelTypeHighwayVeh",
        "en": "Electricity",
        "fr": "Électricité"
    },
    {
        "key": "Dies",
        "group": "fuelTypeFacilityVeh",
        "en": "Diesel",
        "fr": "Diesel"
    },
    {
        "key": "Gas",
        "group": "fuelTypeFacilityVeh",
        "en": "Gasoline",
        "fr": "Essence"
    },
    {
        "key": "Elec",
        "group": "fuelTypeFacilityVeh",
        "en": "Electricity",
        "fr": "Électricité"
    },
    {
        "key": "B100",
        "group": "fuelType",
        "en": "B100 (100% biodiesel)",
        "fr": "B100 (100% biodiesel)"
    },
    {
        "key": "BBL",
        "group": "fuelType",
        "en": "Biodiesel blend",
        "fr": "Mélange biodiesel"
    },
    {
        "key": "Dies",
        "group": "fuelType",
        "en": "Diesel",
        "fr": "Diesel"
    },
    {
        "key": "E100",
        "group": "fuelType",
        "en": "E100 (100% ethanol)",
        "fr": "E100 (100% éthanol)"
    },
    {
        "key": "EBL",
        "group": "fuelType",
        "en": "Gasoline/ethanol blend",
        "fr": "Essence/mélange éthanol"
    },
    {
        "key": "Elec",
        "group": "fuelType",
        "en": "Electricity",
        "fr": "Électricité"
    },
    {
        "key": "Gas",
        "group": "fuelType",
        "en": "Gasoline",
        "fr": "Essence"
    },
    {
        "key": "Gas2",
        "group": "fuelType",
        "en": "2-Stroke Mix Gasoline",
        "fr": "Mélange essence pour moteur à deux temps"
    },
    {
        "key": "HOIL",
        "group": "fuelType",
        "en": "Heating oil",
        "fr": "Mazout de chauffage"
    },
    {
        "key": "LNG",
        "group": "fuelType",
        "en": "Liquefied natural gas (LNG)",
        "fr": "Gaz naturel liquéfié (GNL)"
    },
    {
        "key": "NatG",
        "group": "fuelType",
        "en": "Natural Gas",
        "fr": "Gaz naturel"
    },
    {
        "key": "Prop",
        "group": "fuelType",
        "en": "Propane (LPG)",
        "fr": "Propane (GPL)"
    },
    {
        "key": "ULSD",
        "group": "fuelType",
        "en": "0.0015% S Ultra Low Sulphur Diesel",
        "fr": "0,0015% S Carburant diésel à très faible teneur en soufre"
    },
    {
        "key": "MDO",
        "group": "fuelType",
        "en": "0.1% S Marine Diesel Oil",
        "fr": "0,1% S Mazout marin"
    },
    {
        "key": "HFO",
        "group": "fuelType",
        "en": "2.6% S Heavy Fuel Oil",
        "fr": "2,6% S Mazout lourd"
    },
    {
        "key": "VLSFO",
        "group": "fuelType",
        "en": "0.5% S Very Low Sulphur Fuel Oil",
        "fr": "0,5% S Mazout à très faible teneur en soufre"
    },
    {
        "key": "Emuls",
        "group": "retrofit",
        "en": "Diesel/water emulsion",
        "fr": "Diesel/émulsion d'eau"
    },
    {
        "key": "None",
        "group": "retrofit",
        "en": "None",
        "fr": "Aucun"
    },
    {
        "key": "Ocert",
        "group": "retrofit",
        "en": "On-road certified engine",
        "fr": "Moteur certifié pour la route"
    },
    {
        "key": "Ortu",
        "group": "retrofit",
        "en": "On-road technology upgrade",
        "fr": "Amélioration à la technologie de route"
    },
    {
        "key": "OxCat",
        "group": "retrofit",
        "en": "Diesel oxidation catalyst (DOC)",
        "fr": "Catalyseur à oxydation diesel (DOC)"
    },
    {
        "key": "Pfilt",
        "group": "retrofit",
        "en": "Diesel particulate filter (DPF)",
        "fr": "Filtre à particules (DPF)"
    },
    {
        "key": "ReCat",
        "group": "retrofit",
        "en": "Selective catalytic reduction (SCR)",
        "fr": "Réduction catalytique sélective (SCR)"
    },
    {
        "key": "Acomp",
        "group": "equipmentTypeCHE",
        "en": "Air Compressors",
        "fr": "Compresseurs d'air"
    },
    {
        "key": "ACref",
        "group": "equipmentTypeCHE",
        "en": "AC/Refrigeration",
        "fr": "Climatiseurs/réfrigération"
    },
    {
        "key": "Alift",
        "group": "equipmentTypeCHE",
        "en": "Aerial Lifts",
        "fr": "Nacelle élévatrice - aerial lifts"
    },
    {
        "key": "BoilT",
        "group": "equipmentTypeCHE",
        "en": "Boilers - Material Transfer",
        "fr": "Chaudières - Transfert de matière"
    },
    {
        "key": "Conv",
        "group": "equipmentTypeCHE",
        "en": "Conveyors",
        "fr": "Convoyeurs"
    },
    {
        "key": "C-Oth",
        "group": "equipmentTypeCHE",
        "en": "Cranes - other",
        "fr": "Grues - autres"
    },
    {
        "key": "Crane",
        "group": "equipmentTypeCHE",
        "en": "Cranes (not RTG)",
        "fr": "Grues (pas RTG)"
    },
    {
        "key": "Craw",
        "group": "equipmentTypeCHE",
        "en": "Crawler Tractor/Dozers",
        "fr": "Tracteurs à chenilles/bouteurs"
    },
    {
        "key": "C-RMG",
        "group": "equipmentTypeCHE",
        "en": "Cranes - rail mounted gantry (RMG)",
        "fr": "Grues - à portique sur rail (RMG)"
    },
    {
        "key": "C-RTG",
        "group": "equipmentTypeCHE",
        "en": "Cranes - rubber tire gantry (RTG)",
        "fr": "Grues - à portique de manœuvre sur pneus (RTG)"
    },
    {
        "key": "Crush",
        "group": "equipmentTypeCHE",
        "en": "Crushers/grinders",
        "fr": "Concasseurs/broyeurs"
    },
    {
        "key": "Cstak",
        "group": "equipmentTypeCHE",
        "en": "Chassis Stackers",
        "fr": "Châssis empileurs"
    },
    {
        "key": "C-STS",
        "group": "equipmentTypeCHE",
        "en": "Cranes - ship to shore",
        "fr": "Ponts roulants STS (ship-to-shore)"
    },
    {
        "key": "Elec",
        "group": "equipmentTypeCHE",
        "en": "Electrical Equipment (General, Not Generators)",
        "fr": "Équipement électrique (général, pas de génératrices)"
    },
    {
        "key": "Estak",
        "group": "equipmentTypeCHE",
        "en": "Reach Stackers",
        "fr": "Empileurs"
    },
    {
        "key": "Excav",
        "group": "equipmentTypeCHE",
        "en": "Excavators (normal/adapted for logs)",
        "fr": "Excavatrices (normales/adaptées pour les bûches)"
    },
    {
        "key": "Felle",
        "group": "equipmentTypeCHE",
        "en": "Feller/Bunchers",
        "fr": "Abatteuses-empileuses"
    },
    {
        "key": "Fork",
        "group": "equipmentTypeCHE",
        "en": "Forklifts",
        "fr": "Chariots élévateurs"
    },
    {
        "key": "Gcomp",
        "group": "equipmentTypeCHE",
        "en": "Gas Compressors",
        "fr": "Compresseurs de gaz"
    },
    {
        "key": "GenSt",
        "group": "equipmentTypeCHE",
        "en": "Generator Sets",
        "fr": "Groupes électrogènes"
    },
    {
        "key": "PumpT",
        "group": "equipmentTypeCHE",
        "en": "Pumps - Transfer",
        "fr": "Pompes - transfert"
    },
    {
        "key": "PumpW",
        "group": "equipmentTypeCHE",
        "en": "Pumps - Water",
        "fr": "Pompes - eau"
    },
    {
        "key": "Pwash",
        "group": "equipmentTypeCHE",
        "en": "Pressure Washers",
        "fr": "Laveuses à pression"
    },
    {
        "key": "Rload",
        "group": "equipmentTypeCHE",
        "en": "Rubber-Tire Loaders",
        "fr": "Chargeurs à pneus en caoutchouc"
    },
    {
        "key": "Rolle",
        "group": "equipmentTypeCHE",
        "en": "Roller/compactors",
        "fr": "Rouleaux/compacteurs"
    },
    {
        "key": "RTG",
        "group": "equipmentTypeCHE",
        "en": "Rubber Tire Gantry (RTG) cranes",
        "fr": "Grues à portique avec pneus en caoutchouc (RTG)"
    },
    {
        "key": "Sbrd",
        "group": "equipmentTypeCHE",
        "en": "Signal Boards/Light Plants",
        "fr": "Panneaux de signalisation/installations lumineuses"
    },
    {
        "key": "Sload",
        "group": "equipmentTypeCHE",
        "en": "Skid Steer Loaders (small loaders)",
        "fr": "Chargeurs à direction à glissement (petits chargeurs)"
    },
    {
        "key": "Sweep",
        "group": "equipmentTypeCHE",
        "en": "Sweepers/Scrubbers",
        "fr": "Balayeuses/brosseuses"
    },
    {
        "key": "Tpick",
        "group": "equipmentTypeCHE",
        "en": "Top or Side Picks Chassis or Reach Stackers",
        "fr": "Châssis à pioches latérale ou dessus ou gerbeurs"
    },
    {
        "key": "Trac",
        "group": "equipmentTypeCHE",
        "en": "Tractors/Loaders/Backhoes",
        "fr": "Tracteurs/chargeuses/pelles rétrocaveuses"
    },
    {
        "key": "Truck",
        "group": "equipmentTypeCHE",
        "en": "Off-Hwy Truck (Not registered for on-road use)",
        "fr": "Camions hors route (pas enregistrés comme véhicules routiers)"
    },
    {
        "key": "Weld",
        "group": "equipmentTypeCHE",
        "en": "Welders",
        "fr": "Machines à souder"
    },
    {
        "key": "Yard",
        "group": "equipmentTypeCHE",
        "en": "Yard trucks (Hostler, Goats, Terminal Tractors)",
        "fr": "Camions de triage (tracteurs de manœuvre, de terminal)"
    },
    {
        "key": "Boil",
        "group": "equipmentTypeAdmin",
        "en": "Boiler",
        "fr": "Chaudière"
    },
    {
        "key": "Elec",
        "group": "equipmentTypeAdmin",
        "en": "General admin electricity",
        "fr": "Électricité - admin générale"
    },
    {
        "key": "Gen",
        "group": "equipmentTypeAdmin",
        "en": "Generator",
        "fr": "Génératrice"
    },
    {
        "key": "A",
        "group": "commodityType",
        "en": "Autos",
        "fr": "Véhicules"
    },
    {
        "key": "BB",
        "group": "commodityType",
        "en": "Breakbulk",
        "fr": "Marchandises générales"
    },
    {
        "key": "BBLO",
        "group": "commodityType",
        "en": "Breakbulk - Logs",
        "fr": "Marchandises générales - billots"
    },
    {
        "key": "BBLU",
        "group": "commodityType",
        "en": "Breakbulk - Lumber",
        "fr": "Marchandises générales - bois dœuvre"
    },
    {
        "key": "BBM",
        "group": "commodityType",
        "en": "Breakbulk - Metals",
        "fr": "Marchandises générales - métaux"
    },
    {
        "key": "BBP",
        "group": "commodityType",
        "en": "Breakbulk - Paper products",
        "fr": "Marchandises générales - produits papetiers"
    },
    {
        "key": "BBW",
        "group": "commodityType",
        "en": "Breakbulk - Woodpulp, chips, hog",
        "fr": "Marchandises générales - pâte, copeaux"
    },
    {
        "key": "BL",
        "group": "commodityType",
        "en": "Bulk Liquid",
        "fr": "Vrac liquide"
    },
    {
        "key": "BLC",
        "group": "commodityType",
        "en": "Bulk Liquid - Chemicals",
        "fr": "Vrac liquide - produits chimiques"
    },
    {
        "key": "BLM",
        "group": "commodityType",
        "en": "Bulk Liquid - Molasses",
        "fr": "Vrac liquide - mélasses"
    },
    {
        "key": "BLO",
        "group": "commodityType",
        "en": "Bulk Liquid - Animal & vegetable oils, fats & waxes",
        "fr": "Vrac liquide - huiles animales et végétales, graisses et cires"
    },
    {
        "key": "BLP",
        "group": "commodityType",
        "en": "Bulk Liquid - Petroleum products",
        "fr": "Vrac liquide - produits pétroliers"
    },
    {
        "key": "BS",
        "group": "commodityType",
        "en": "Bulk Solid",
        "fr": "Vrac solide"
    },
    {
        "key": "BSC",
        "group": "commodityType",
        "en": "Bulk Solid - Chemicals",
        "fr": "Vrac solide - produits chimiques"
    },
    {
        "key": "BSCG",
        "group": "commodityType",
        "en": "Bulk Solid - Gypsum",
        "fr": "Vrac solide - gypse"
    },
    {
        "key": "BSCO",
        "group": "commodityType",
        "en": "Bulk Solid - Coal",
        "fr": "Vrac solide - charbon"
    },
    {
        "key": "BSF",
        "group": "commodityType",
        "en": "Bulk Solid - Fish",
        "fr": "Vrac solide - poisson"
    },
    {
        "key": "BSFZ",
        "group": "commodityType",
        "en": "Bulk Solid - Fertilizer",
        "fr": "Vrac solide - engrais"
    },
    {
        "key": "BSG",
        "group": "commodityType",
        "en": "Bulk Solid - Grain, special crops and feed",
        "fr": "Vrac solide - céréales, cultures spéciales et alimentation animale"
    },
    {
        "key": "BSI",
        "group": "commodityType",
        "en": "Bulk Solid - Iron and steel products",
        "fr": "Vrac solide - produits sidérurgiques"
    },
    {
        "key": "BSM",
        "group": "commodityType",
        "en": "Bulk Solid - Construction materials",
        "fr": "Vrac solide - matériaux de construction"
    },
    {
        "key": "BSO",
        "group": "commodityType",
        "en": "Bulk Solid - Other ore and mineral products",
        "fr": "Vrac solide - autres produits minérai"
    },
    {
        "key": "BSP",
        "group": "commodityType",
        "en": "Bulk Solid - Potash",
        "fr": "Vrac solide - potasse"
    },
    {
        "key": "BSS",
        "group": "commodityType",
        "en": "Bulk Solid - Sulphur",
        "fr": "Vrac solide - souffre"
    },
    {
        "key": "BSST",
        "group": "commodityType",
        "en": "Bulk Solid - Salt",
        "fr": "Vrac solide - sel"
    },
    {
        "key": "C",
        "group": "commodityType",
        "en": "Containers",
        "fr": "Conteneurs"
    },
    {
        "key": "P",
        "group": "commodityType",
        "en": "Passengers (Cruise/Ferry)",
        "fr": "Passagers (Croisière/Traversier)"
    },
    {
        "key": "S",
        "group": "commodityType",
        "en": "Other",
        "fr": "Autre"
    },
    {
        "key": "2024",
        "group": "invYear",
        "en": "2024",
        "fr": "2024"
    },
    {
        "key": "2023",
        "group": "invYear",
        "en": "2023",
        "fr": "2023"
    },
    {
        "key": "2022",
        "group": "invYear",
        "en": "2022",
        "fr": "2022"
    },
    {
        "key": "2021",
        "group": "invYear",
        "en": "2021",
        "fr": "2021"
    },
    {
        "key": "2020",
        "group": "invYear",
        "en": "2020",
        "fr": "2020"
    },
    {
        "key": "2019",
        "group": "invYear",
        "en": "2019",
        "fr": "2019"
    },
    {
        "key": "2018",
        "group": "invYear",
        "en": "2018",
        "fr": "2018"
    },
    {
        "key": "2017",
        "group": "invYear",
        "en": "2017",
        "fr": "2017"
    },
    {
        "key": "2016",
        "group": "invYear",
        "en": "2016",
        "fr": "2016"
    },
    {
        "key": "2015",
        "group": "invYear",
        "en": "2015",
        "fr": "2015"
    },
    {
        "key": "2014",
        "group": "invYear",
        "en": "2014",
        "fr": "2014"
    },
    {
        "key": "2013",
        "group": "invYear",
        "en": "2013",
        "fr": "2013"
    },
    {
        "key": "2012",
        "group": "invYear",
        "en": "2012",
        "fr": "2012"
    },
    {
        "key": "2011",
        "group": "invYear",
        "en": "2011",
        "fr": "2011"
    },
    {
        "key": "2010",
        "group": "invYear",
        "en": "2010",
        "fr": "2010"
    },
    {
        "key": "hp",
        "group": "powerUnits",
        "en": "horsepower (hp)",
        "fr": "horsepower (hp)"
    },
    {
        "key": "kw",
        "group": "powerUnits",
        "en": "kilowatt (kW)",
        "fr": "kilowatt (kW)"
    },
    {
        "key": "BTU/h",
        "group": "powerUnits",
        "en": "British Thermal Unit per hour (BTU/h)",
        "fr": "unité thermique britannique par heure (BTU/h)"
    },
    {
        "key": "BNSF",
        "group": "serviceProvider",
        "en": "BNSF",
        "fr": "BNSF"
    },
    {
        "key": "CN",
        "group": "serviceProvider",
        "en": "CN",
        "fr": "CN"
    },
    {
        "key": "CP",
        "group": "serviceProvider",
        "en": "CPKC/CP",
        "fr": "CPKC/CP"
    },
    {
        "key": "CSX",
        "group": "serviceProvider",
        "en": "CSX",
        "fr": "CSX"
    },
    {
        "key": "Other",
        "group": "serviceProvider",
        "en": "Other",
        "fr": "Autre"
    },
    {
        "key": "NS",
        "group": "trainTypeOther",
        "en": "NS",
        "fr": "NS"
    },
    {
        "key": "Other",
        "group": "trainTypeOther",
        "en": "Other",
        "fr": "Autre"
    },
    {
        "key": "OTHLL",
        "group": "trainTypeOther",
        "en": "Other - Large Line Haul",
        "fr": "Autre - grand service ferroviaire"
    },
    {
        "key": "OTHSL",
        "group": "trainTypeOther",
        "en": "Other - Smaller Line Haul",
        "fr": "Autre – service ferroviaire de plus petite taille"
    },
    {
        "key": "UP",
        "group": "trainTypeOther",
        "en": "UP",
        "fr": "UP"
    },
    {
        "key": "Port",
        "group": "trainOwnership",
        "en": "Port owned or leased",
        "fr": "Détenue ou louée par le port"
    },
    {
        "key": "Term",
        "group": "trainOwnership",
        "en": "Terminal/facility owned or leased",
        "fr": "Détenu ou louée par le terminal ou l'installation"
    },
    {
        "key": "Average switch duty cycle",
        "group": "workDone",
        "en": "Average switch duty cycle",
        "fr": "Cycle d’utilisation moyen de la locomotive de manœuvres"
    },
    {
        "key": "Minimal work - idling",
        "group": "workDone",
        "en": "Minimal work - idling",
        "fr": "Travail minime – marche au ralenti"
    },
    {
        "key": "gen2",
        "group": "modelType",
        "en": "Genset - 2 Eng",
        "fr": "Groupe électrogène à 2 moteurs"
    },
    {
        "key": "gen3",
        "group": "modelType",
        "en": "Genset - 3 Eng",
        "fr": "Groupe électrogène à 3 moteurs"
    },
    {
        "key": "line",
        "group": "modelType",
        "en": "Conventional line haul",
        "fr": "Transport ferroviaire classique"
    },
    {
        "key": "lines",
        "group": "modelType",
        "en": "Conventional line haul - small",
        "fr": "Transport ferroviaire classique - petit"
    },
    {
        "key": "other",
        "group": "modelType",
        "en": "Other",
        "fr": "Autre"
    },
    {
        "key": "rcp",
        "group": "modelType",
        "en": "Rail car pusher (e.g., Rail King)",
        "fr": "Locomotive de renfort (p. ex., Rail King)"
    },
    {
        "key": "swit",
        "group": "modelType",
        "en": "Conventional switch",
        "fr": "Locomotive de manoeuvres classique"
    },
    {
        "key": "Dies",
        "group": "fuelTypeTrain",
        "en": "Diesel",
        "fr": "Diesel"
    },
    {
        "key": "B100",
        "group": "fuelTypeTrain",
        "en": "B100 (100% biodiesel)",
        "fr": "B100 (100% biodiesel)"
    },
    {
        "key": "BBL",
        "group": "fuelTypeTrain",
        "en": "Biodiesel blend",
        "fr": "Mélange biodiesel"
    },
    {
        "key": "terminalName",
        "group": "introduction",
        "en": "Terminal/facility name",
        "fr": "Nom du terminal ou de l'installation"
    },
    {
        "key": "invYear",
        "group": "introduction",
        "en": "Inventory year",
        "fr": "Année d'inventaire"
    },
    {
        "key": "portAuthority",
        "group": "introduction",
        "en": "Port authority",
        "fr": "Administration portuaire"
    },
    {
        "key": "globalwarning",
        "group": "introduction",
        "en": "Global Warming Potential Values",
        "fr": "Valeurs de potentiel de réchauffement planétaire"
    },
    {
        "key": "province",
        "group": "introduction",
        "en": "Province or territory / other",
        "fr": "Province, territoire ou autre"
    },
    {
        "key": "scenario",
        "group": "introduction",
        "en": "Global Warming Potential Values",
        "fr": "Valeurs de potentiel de réchauffement planétaire"
    },
    {
        "key": "commodityType",
        "group": "terminal",
        "en": "Commodity type",
        "fr": "Type de marchandises"
    },
    {
        "key": "annualThroughput",
        "group": "terminal",
        "en": "Annual throughput",
        "fr": "Débit annuel"
    },
    {
        "key": "units",
        "group": "terminal",
        "en": "Units of measure",
        "fr": "Unités de mesure"
    },
    {
        "key": "notes",
        "group": "terminal",
        "en": "Notes/comments",
        "fr": "Remarques/commentaires"
    },
    {
        "key": "terminal",
        "group": "terminalH",
        "en": "Annual commodity throughput for terminal/facility",
        "fr": "Débit annuel des marchandises pour le terminal ou l'installation"
    },
    {
        "key": "equipmentType",
        "group": "admin",
        "en": "Energy/equipment type",
        "fr": "Énergie/type d'équipement"
    },
    {
        "key": "fuelType",
        "group": "admin",
        "en": "Fuel type",
        "fr": "Type de carburant"
    },
    {
        "key": "totalAnnualConsumption",
        "group": "admin",
        "en": "Total annual consumption",
        "fr": "Consommation annuelle totale"
    },
    {
        "key": "units",
        "group": "admin",
        "en": "Units of measure",
        "fr": "Unités de mesure"
    },
    {
        "key": "notes",
        "group": "admin",
        "en": "Notes/comments",
        "fr": "Remarques/commentaires"
    },
    {
        "key": "admin",
        "group": "adminH",
        "en": "Administrative energy consumption",
        "fr": "Consommation d’énergie des installations administratives"
    },
    {
        "key": "zone",
        "group": "marine",
        "en": "Zones",
        "fr": "Zones"
    },
    {
        "key": "location",
        "group": "marine",
        "en": "Berths/Anchorages",
        "fr": "Postes d'amarrage ou de mouillage"
    },
    {
        "key": "ship",
        "group": "marine",
        "en": "IMO number and/or ship name",
        "fr": "Numéro OMI et/ou nom du navire"
    },
    {
        "key": "active",
        "group": "marine",
        "en": "Active",
        "fr": "Actif"
    },
    {
        "key": "name",
        "group": "marine",
        "en": "Name",
        "fr": "Nom"
    },
    {
        "key": "color",
        "group": "marine",
        "en": "Colour",
        "fr": "Couleur"
    },
    {
        "key": "zoneId",
        "group": "marine",
        "en": "Zones",
        "fr": "Zones"
    },
    {
        "key": "fuelType",
        "group": "che",
        "en": "Fuel type",
        "fr": "Type de carburant"
    },
    {
        "key": "annualFuel",
        "group": "che",
        "en": "Annual fuel consumption",
        "fr": "Consommation annuelle de carburant"
    },
    {
        "key": "units",
        "group": "che",
        "en": "Units of measure",
        "fr": "Unités mesure"
    },
    {
        "key": "notes",
        "group": "che",
        "en": "Notes/comments",
        "fr": "Remarques/commentaires"
    },
    {
        "key": "equipmentType",
        "group": "che",
        "en": "Equipment type",
        "fr": "Type d'équipement"
    },
    {
        "key": "modelYear",
        "group": "che",
        "en": "Engine model year",
        "fr": "Année de modèle du moteur"
    },
    {
        "key": "similarUnits",
        "group": "che",
        "en": "Number of similar units",
        "fr": "Nombre d'unités similaires"
    },
    {
        "key": "isRetrofit",
        "group": "che",
        "en": "Retrofit installed?",
        "fr": "Adaptation antipollution installée?"
    },
    {
        "key": "retrofitType",
        "group": "che",
        "en": "Retrofit type",
        "fr": "Type d'adaptation antipollution"
    },
    {
        "key": "fuelId",
        "group": "che",
        "en": "Fuel type (see table above)",
        "fr": "Type de carburant (voir tableau ci-haut)"
    },
    {
        "key": "enginePower",
        "group": "che",
        "en": "Engine power or boiler rating",
        "fr": "Puissance du moteur ou cote de rendement de la chaudière"
    },
    {
        "key": "powerUnits",
        "group": "che",
        "en": "Units of measure",
        "fr": "Unités de mesure"
    },
    {
        "key": "annualHours",
        "group": "che",
        "en": "Annual hours of use (for one unit)",
        "fr": "Nombres d’heures d’utilisation par année (pour une unité)"
    },
    {
        "key": "fuel",
        "group": "cheH",
        "en": "Annual fuel consumption for terminal/facility CHE",
        "fr": "Consommation annuelle de carburant pour les EMF du terminal ou de l'installation"
    },
    {
        "key": "equipment",
        "group": "cheH",
        "en": "Equipment List",
        "fr": "Liste des équipements"
    },
    {
        "key": "annualGateCounts",
        "group": "road",
        "en": "Annual gate counts",
        "fr": "Dénombrement annuel à la barrière"
    },
    {
        "key": "cTime",
        "group": "road",
        "en": "Average time spent on terminal/facility grounds (min)",
        "fr": "Temps moyen passé sur le site du terminal ou de l’installation (minutes)"
    },
    {
        "key": "cDriving",
        "group": "road",
        "en": "Average time driving on terminal/facility grounds (min)",
        "fr": "Temps moyen de conduite sur le site du terminal ou de l’installation (minutes)"
    },
    {
        "key": "cIdling",
        "group": "road",
        "en": "Average time idling on terminal/facility grounds (min)",
        "fr": "Temps moyen passé en marche au ralenti sur le territoire du terminal ou de l'installation (minutes)"
    },
    {
        "key": "ageProfile",
        "group": "road",
        "en": "Vehicle age profile",
        "fr": "Profil d'âge des véhicules"
    },
    {
        "key": "dEntry",
        "group": "road",
        "en": "Distance from terminal to port entry/intermodal point (km)",
        "fr": "Distance entre le terminal et le point d’entrée du port ou le point multimodal (km)"
    },
    {
        "key": "dExit",
        "group": "road",
        "en": "Distance from terminal to port exit/intermodal point (km)",
        "fr": "Distance entre le terminal et la sortie du port/point multimodal (km)"
    },
    {
        "key": "dIdling",
        "group": "road",
        "en": "Average time idling on port grounds (min)",
        "fr": "Temps moyen passé en marche au ralenti sur site du port (minutes)"
    },
    {
        "key": "dSpeed",
        "group": "road",
        "en": "Average speed driven on port grounds (km/h)",
        "fr": "Vitesse moyenne sur le site du port (km/h)"
    },
    {
        "key": "fuelType",
        "group": "road",
        "en": "Fuel type",
        "fr": "Type de carburant"
    },
    {
        "key": "annualFuel",
        "group": "road",
        "en": "Annual fuel consumption",
        "fr": "Consommation annuelle de carburant"
    },
    {
        "key": "units",
        "group": "road",
        "en": "Units of measure",
        "fr": "Unités de mesure"
    },
    {
        "key": "notes",
        "group": "road",
        "en": "Notes/comments",
        "fr": "Remarques/commentaires"
    },
    {
        "key": "vehicleType",
        "group": "road",
        "en": "Vehicle type",
        "fr": "Type de véhicule"
    },
    {
        "key": "modelYear",
        "group": "road",
        "en": "Vehicle model year",
        "fr": "Année de modèle du véhicule"
    },
    {
        "key": "numberVechicles",
        "group": "road",
        "en": "Number of similar vehicles",
        "fr": "Nombre de véhicules similaires"
    },
    {
        "key": "intensity",
        "group": "road",
        "en": "Relative intensity of use",
        "fr": "Intensité relative de l'utilisation"
    },
    {
        "key": "fuelId",
        "group": "road",
        "en": "Fuel type (see table above)",
        "fr": "Type de carburant (voir tableau ci-haut)"
    },
    {
        "key": "numberVechicles",
        "group": "road",
        "en": "Number of vehicles",
        "fr": "Nombre de véhicules"
    },
    {
        "key": "age",
        "group": "road",
        "en": "Age",
        "fr": "Âge"
    },
    {
        "key": "number",
        "group": "road",
        "en": "Number",
        "fr": "Nombre"
    },
    {
        "key": "percentage",
        "group": "road",
        "en": "Percentage",
        "fr": "Pourcentage"
    },
    {
        "key": "vehicle",
        "group": "roadH",
        "en": "List of terminal/facility vehicles",
        "fr": "Véhicules du terminal ou de l'installation"
    },
    {
        "key": "highway",
        "group": "roadH",
        "en": "Highway vehicles (not operated by terminal/facility)",
        "fr": "Véhicules routiers (non opérés par le terminal ou l'installation)"
    },
    {
        "key": "profile",
        "group": "roadH",
        "en": "Custom highway vehicle age fleet profile (OPTIONAL)",
        "fr": "Profil personnalisé d'âge des véhicules routiers (OPTIONNEL)"
    },
    {
        "key": "fuel",
        "group": "roadH",
        "en": "Annual fuel consumption for terminal/facility vehicles",
        "fr": "Consommation annuelle de carburant des véhicules du terminal ou de l'installation"
    },
    {
        "key": "name",
        "group": "road",
        "en": "Name",
        "fr": "Nom"
    },
    {
        "key": "notes",
        "group": "road",
        "en": "Notes/comments",
        "fr": "Remarques/commentaires"
    },
    {
        "key": "national",
        "group": "rail",
        "en": "National/regional rail",
        "fr": "Transport ferroviaire national et régional"
    },
    {
        "key": "facility",
        "group": "rail",
        "en": "Port & terminal/facility locomotives",
        "fr": "Locomotives du port et locomotives du terminal ou de l'installation"
    },
    {
        "key": "serviceProvider",
        "group": "rail",
        "en": "Service provider",
        "fr": "Fournisseur du service"
    },
    {
        "key": "annualTrainVisits",
        "group": "rail",
        "en": "Annual train visits to terminal/facility",
        "fr": "Nombre de visites des trains sur le site du terminal ou de l’installation, chaque année"
    },
    {
        "key": "averageInbound",
        "group": "rail",
        "en": "Average net tonnage/train inbound (tonnes)",
        "fr": "Tonnage net moyen du train entrant (tonnes)"
    },
    {
        "key": "averageOutbound",
        "group": "rail",
        "en": "Average net tonnage/train outbound (tonnes)",
        "fr": "Tonnage net moyen du train sortant (tonnes)"
    },
    {
        "key": "distanceTerminalPort",
        "group": "rail",
        "en": "Distance from terminal to port boundary (km)",
        "fr": "Distance entre le terminal et les limites du port (km)"
    },
    {
        "key": "timeSpent",
        "group": "rail",
        "en": "Average time spent on terminal/facility grounds (h)",
        "fr": "Temps moyen passé sur le site du terminal ou de l’installation (h)"
    },
    {
        "key": "workDone",
        "group": "rail",
        "en": "Work done while on terminal/facility grounds",
        "fr": "Travaux effectués sur le site du terminal ou de l’installation"
    },
    {
        "key": "notes",
        "group": "rail",
        "en": "Notes/comments",
        "fr": "Remarques/commentaires"
    },
    {
        "key": "ownership",
        "group": "rail",
        "en": "Ownership",
        "fr": "Propriété"
    },
    {
        "key": "model",
        "group": "rail",
        "en": "Model",
        "fr": "Modèle"
    },
    {
        "key": "engineYear",
        "group": "rail",
        "en": "Engine year/tier",
        "fr": "Année/niveau du moteur"
    },
    {
        "key": "fuelTypeTrain",
        "group": "rail",
        "en": "Fuel type",
        "fr": "Type de carburant"
    },
    {
        "key": "annualFuel",
        "group": "rail",
        "en": "Annual fuel consumption",
        "fr": "Consommation annuelle de carburant"
    },
    {
        "key": "units",
        "group": "rail",
        "en": "Units of measure",
        "fr": "Unités de mesure"
    },
    {
        "key": "numberUnits",
        "group": "rail",
        "en": "Number of similar units",
        "fr": "Nombre d'unités similaires"
    },
    {
        "key": "pre",
        "group": "trainAgeProfile",
        "en": "2001 and older",
        "fr": "2001 et années antérieures"
    },
    {
        "key": "0+",
        "group": "trainAgeProfile",
        "en": "Tier 0+",
        "fr": "Niveau 0+"
    },
    {
        "key": "0",
        "group": "trainAgeProfile",
        "en": "2001 and older, rebuilt (Tier 0)",
        "fr": "2001 et années antérieures, reconstruit (niveau 0)"
    },
    {
        "key": "1",
        "group": "trainAgeProfile",
        "en": "2002 - 2004 (Tier 1)",
        "fr": "2002 - 2004 (niveau 1)"
    },
    {
        "key": "1+",
        "group": "trainAgeProfile",
        "en": "Tier 1+",
        "fr": "Niveau 1+"
    },
    {
        "key": "2",
        "group": "trainAgeProfile",
        "en": "2005 - 2010 (Tier 2)",
        "fr": "2005 - 2010 (niveau 2)"
    },
    {
        "key": "2+",
        "group": "trainAgeProfile",
        "en": "Tier 2+",
        "fr": "Niveau 2+"
    },
    {
        "key": "3",
        "group": "trainAgeProfile",
        "en": "2011 - 2014 (Tier 3)",
        "fr": "2011 - 2014 (niveau 3)"
    },
    {
        "key": "4",
        "group": "trainAgeProfile",
        "en": "2015 and newer (Tier 4)",
        "fr": "2015 et années ultérieures (niveau 4)"
    },
    {
        "key": "NNMO",
        "group": "port",
        "en": "Nanaimo Port Authority",
        "fr": "Administration portuaire de Nanaimo"
    },
    {
        "key": "PALB",
        "group": "port",
        "en": "Port Alberni Port Authority",
        "fr": "Administration portuaire de Port Alberni"
    },
    {
        "key": "PRPA",
        "group": "port",
        "en": "Prince Rupert Port Authority",
        "fr": "Administration portuaire de Prince Rupert"
    },
    {
        "key": "VFPA",
        "group": "port",
        "en": "Vancouver Fraser Port Authority",
        "fr": "Administration portuaire Vancouver-Fraser"
    },
    {
        "key": "HOPA",
        "group": "port",
        "en": "Hamilton-Oshawa Port Authority",
        "fr": "Administration portuaire Hamilton-Oshawa"
    },
    {
        "key": "TPA",
        "group": "port",
        "en": "Toronto Port Authority",
        "fr": "Administration portuaire de Toronto"
    },
    {
        "key": "TBPA",
        "group": "port",
        "en": "Thunder Bay Port Authority",
        "fr": "Administration portuaire de Thunder Bay"
    },
    {
        "key": "WPA",
        "group": "port",
        "en": "Windsor Port Authority",
        "fr": "Administration portuaire de Windsor"
    },
    {
        "key": "MPA",
        "group": "port",
        "en": "Montreal Port Authority",
        "fr": "Administration portuaire de Montréal"
    },
    {
        "key": "QPA",
        "group": "port",
        "en": "Quebec Port Authority",
        "fr": "Administration portuaire de Québec"
    },
    {
        "key": "SPA",
        "group": "port",
        "en": "Saguenay Port Authority",
        "fr": "Administration portuaire de Saguenay"
    },
    {
        "key": "SIPA",
        "group": "port",
        "en": "Sept-Îles Port Authority",
        "fr": "Administration portuaire de Sept-Îles"
    },
    {
        "key": "TRPA",
        "group": "port",
        "en": "Trois-Rivières Port Authority",
        "fr": "Administration portuaire de Trois-Rivières"
    },
    {
        "key": "BPA",
        "group": "port",
        "en": "Belledune Port Authority",
        "fr": "Administration portuaire de Belledune"
    },
    {
        "key": "SJNB",
        "group": "port",
        "en": "Saint John Port Authority",
        "fr": "Administration portuaire de Saint John"
    },
    {
        "key": "HXPA",
        "group": "port",
        "en": "Halifax Port Authority",
        "fr": "Administration portuaire d’Halifax"
    },
    {
        "key": "SJPA",
        "group": "port",
        "en": "St. John’s Port Authority",
        "fr": "Administration portuaire de St. John’s"
    },
    {
        "key": "Other",
        "group": "port",
        "en": "Other",
        "fr": "Autre"
    },
    {
        "key": "Avg",
        "group": "ageProfile",
        "en": "Average / not known",
        "fr": "Moyen / inconnu"
    },
    {
        "key": "UserA",
        "group": "ageProfile",
        "en": "User-defined A",
        "fr": "Défini par l'usager A"
    },
    {
        "key": "UserB",
        "group": "ageProfile",
        "en": "User-defined B",
        "fr": "Défini par l'usager B"
    },
    {
        "key": "UserC",
        "group": "ageProfile",
        "en": "User-defined C",
        "fr": "Défini par l'usager C"
    },
    {
        "key": "AR4-20",
        "group": "GPWV",
        "en": "AR4-20",
        "fr": "AR4-20"
    },
    {
        "key": "AR4-100",
        "group": "GPWV",
        "en": "AR4-100",
        "fr": "AR4-100"
    },
    {
        "key": "AR5-20",
        "group": "GPWV",
        "en": "AR5-20",
        "fr": "AR5-20"
    },
    {
        "key": "AR5-100",
        "group": "GPWV",
        "en": "AR5-100",
        "fr": "AR5-100"
    },
    {
        "key": "AR6-20",
        "group": "GPWV",
        "en": "AR6-20",
        "fr": "AR6-20"
    },
    {
        "key": "AR6-100",
        "group": "GPWV",
        "en": "AR6-100",
        "fr": "AR6-100"
    },
    {
        "key": "ItemID",
        "group": "colHeader",
        "en": "ItemID",
        "fr": "Identifiant d'item"
    },
    {
        "key": "InventoryYear",
        "group": "dataColHeader",
        "en": "Inventory year",
        "fr": "Année d'inventaire"
    },
    {
        "key": "PortAuthority",
        "group": "dataColHeader",
        "en": "Port authority",
        "fr": "Administration portuaire"
    },
    {
        "key": "Terminal",
        "group": "dataColHeader",
        "en": "Terminal",
        "fr": "Terminal"
    },
    {
        "key": "Boundary",
        "group": "dataColHeader",
        "en": "Boundary",
        "fr": "Limite"
    },
    {
        "key": "Activity",
        "group": "dataColHeader",
        "en": "Activity",
        "fr": "Activité"
    },
    {
        "key": "SourceGroup",
        "group": "dataColHeader",
        "en": "Source group",
        "fr": "Groupe source"
    },
    {
        "key": "SourceSubGroup",
        "group": "dataColHeader",
        "en": "Source sub-group",
        "fr": "Sous-groupe source"
    },
    {
        "key": "Equipment",
        "group": "dataColHeader",
        "en": "Equipment/type",
        "fr": "Équipement / type"
    },
    {
        "key": "fuel_ID",
        "group": "dataColHeader",
        "en": "Fuel type",
        "fr": "Carburant"
    },
    {
        "key": "ppm_sulphur",
        "group": "dataColHeader",
        "en": "ppm of sulphur",
        "fr": "Teneur en soufre"
    },
    {
        "key": "retro_ID",
        "group": "dataColHeader",
        "en": "Retrofit",
        "fr": "Adaptation antipollution"
    },
    {
        "key": "SubstanceGroup",
        "group": "dataColHeader",
        "en": "Substance group",
        "fr": "Groupe substance"
    },
    {
        "key": "Substance",
        "group": "dataColHeader",
        "en": "Substance",
        "fr": "Substance"
    },
    {
        "key": "SubstanceID",
        "group": "dataColHeader",
        "en": "Substance ID",
        "fr": "Identifiant de substance"
    },
    {
        "key": "Amount",
        "group": "dataColHeader",
        "en": "Amount",
        "fr": "Quantité"
    },
    {
        "key": "unit_ID",
        "group": "dataColHeader",
        "en": "Units",
        "fr": "Unités"
    },
    {
        "key": "SourceGroup",
        "group": "summaryColHeader",
        "en": "Source Group",
        "fr": "Groupe source"
    },
    {
        "key": "SourceSubGroup",
        "group": "summaryColHeader",
        "en": "Equipment / type",
        "fr": "Sous-groupe source"
    },
    {
        "key": "fuel_ID",
        "group": "summaryColHeader",
        "en": "Fuel type",
        "fr": "Carburant"
    },
    {
        "key": "NOx (kg)",
        "group": "colHeader",
        "en": "NOx (kg)",
        "fr": "NOx (kg)"
    },
    {
        "key": "SOx (kg)",
        "group": "colHeader",
        "en": "SOx (kg)",
        "fr": "SOx (kg)"
    },
    {
        "key": "CO (kg)",
        "group": "colHeader",
        "en": "CO (kg)",
        "fr": "CO (kg)"
    },
    {
        "key": "VOC (kg)",
        "group": "colHeader",
        "en": "VOC (kg)",
        "fr": "COV (kg)"
    },
    {
        "key": "PM10 (kg)",
        "group": "colHeader",
        "en": "PM10 (kg)",
        "fr": "MP10 (kg)"
    },
    {
        "key": "PM2.5 (kg)",
        "group": "colHeader",
        "en": "PM2.5 (kg)",
        "fr": "MP2,5 (kg)"
    },
    {
        "key": "NH3 (kg)",
        "group": "colHeader",
        "en": "NH3 (kg)",
        "fr": "NH3 (kg)"
    },
    {
        "key": "DPM (kg)",
        "group": "colHeader",
        "en": "DPM (kg)",
        "fr": "MPD (kg)"
    },
    {
        "key": "Fuel_GJ",
        "group": "colHeader",
        "en": "Fuel (GJ)",
        "fr": "Carburant (GJ)"
    },
    {
        "key": "Fuel_L",
        "group": "colHeader",
        "en": "Fuel (L)",
        "fr": "Carburant (L)"
    },
    {
        "key": "Fuel_kg",
        "group": "colHeader",
        "en": "Fuel (kg)",
        "fr": "Carburant (kg)"
    },
    {
        "key": "BC (kg)",
        "group": "colHeader",
        "en": "BC (kg)",
        "fr": "CN (kg)"
    },
    {
        "key": "CH4 (kg)",
        "group": "colHeader",
        "en": "CH4 (kg)",
        "fr": "CH4 (kg)"
    },
    {
        "key": "THC (kg)",
        "group": "colHeader",
        "en": "THC (kg)",
        "fr": "HCt (kg)"
    },
    {
        "key": "CO2 (kg)",
        "group": "colHeader",
        "en": "CO2 (kg)",
        "fr": "CO2 (kg)"
    },
    {
        "key": "CO2e (kg)",
        "group": "colHeader",
        "en": "CO2e (kg)",
        "fr": "éq. CO2 (kg)"
    },
    {
        "key": "N2O (kg)",
        "group": "colHeader",
        "en": "N2O (kg)",
        "fr": "N2O (kg)"
    },
    {
        "key": "Port Authority",
        "group": "Boundary",
        "en": "Port Authority",
        "fr": "Administration portuaire"
    },
    {
        "key": "Terminal/Facility",
        "group": "Boundary",
        "en": "Terminal/Facility",
        "fr": "Du terminal ou de l'installation"
    },
    {
        "key": "railLoc",
        "group": "SourceGroup",
        "en": "Rail",
        "fr": "Transport ferroviaire"
    },
    {
        "key": "National Rail - CN",
        "group": "SourceSubGroup",
        "en": "National rail - CN",
        "fr": "Transport ferroviaire national - CN"
    },
    {
        "key": "Facility Rail",
        "group": "SourceSubGroup",
        "en": "Terminal/facility rail",
        "fr": "Transport ferroviaire du terminal ou de l'installation"
    },
    {
        "key": "Highway Vehicles",
        "group": "SourceSubGroup",
        "en": "Highway vehicles",
        "fr": "Véhicules routiers"
    },
    {
        "key": "Facility Vehicles",
        "group": "SourceSubGroup",
        "en": "Terminal/facility vehicles",
        "fr": "Véhicules du terminal ou de l'installation"
    },
    {
        "key": "National Rail - CP",
        "group": "SourceSubGroup",
        "en": "National rail - CP",
        "fr": "Transport ferroviaire national - CP"
    },
    {
        "key": "National Rail - BNSF",
        "group": "SourceSubGroup",
        "en": "National rail - BNSF",
        "fr": "Transport ferroviaire national - BNSF"
    },
    {
        "key": "National Rail - Other",
        "group": "SourceSubGroup",
        "en": "National rail - Other",
        "fr": "Transport ferroviaire national - Autre"
    },
    {
        "key": "National Rail - CSX",
        "group": "SourceSubGroup",
        "en": "National rail - CSX",
        "fr": "Transport ferroviaire national - CSX"
    },
    {
        "key": "Transit",
        "group": "Activity",
        "en": "Transit",
        "fr": "En transit"
    },
    {
        "key": "Transfer",
        "group": "Activity",
        "en": "Transfer",
        "fr": "Transfert"
    },
    {
        "key": "All",
        "group": "Activity",
        "en": "All",
        "fr": "Tout"
    },
    {
        "key": "Creep",
        "group": "Activity",
        "en": "Creep",
        "fr": "Déplacement à très basse vitesse"
    },
    {
        "key": "Idle",
        "group": "Activity",
        "en": "Idle",
        "fr": "Marche au ralenti"
    },
    {
        "key": "Anchored",
        "group": "marineActivity",
        "en": "Anchored",
        "fr": "Amarrage"
    },
    {
        "key": "Berthed",
        "group": "marineActivity",
        "en": "Berthed",
        "fr": "Mouillage"
    },
    {
        "key": "Underway",
        "group": "marineActivity",
        "en": "Underway",
        "fr": "En route"
    },
    {
        "key": "N/A",
        "group": "marineActivity",
        "en": "N/A",
        "fr": "S. O."
    },
    {
        "key": "Fuel Used (kg)",
        "group": "Substance",
        "en": "Fuel used (kg)",
        "fr": "Carburant utilisé (kg)"
    },
    {
        "key": "CO",
        "group": "SubstanceID",
        "en": "CO",
        "fr": "CO"
    },
    {
        "key": "ppm_sulphur",
        "group": "SubstanceID",
        "en": "ppm of sulphur",
        "fr": "Teneur en soufre (ppm)"
    },
    {
        "key": "CH4",
        "group": "SubstanceID",
        "en": "CH4",
        "fr": "CH4"
    },
    {
        "key": "NOx",
        "group": "SubstanceID",
        "en": "NOx",
        "fr": "NOx"
    },
    {
        "key": "DPM",
        "group": "SubstanceID",
        "en": "DPM",
        "fr": "MPD"
    },
    {
        "key": "CO2",
        "group": "SubstanceID",
        "en": "CO2",
        "fr": "CO2"
    },
    {
        "key": "CO2e",
        "group": "SubstanceID",
        "en": "CO2e",
        "fr": "éq. CO2 "
    },
    {
        "key": "BC",
        "group": "SubstanceID",
        "en": "BC",
        "fr": "CN"
    },
    {
        "key": "Fuel_mass",
        "group": "SubstanceID",
        "en": "Fuel (kg)",
        "fr": "Carburant (kg)"
    },
    {
        "key": "N2O",
        "group": "SubstanceID",
        "en": "N2O",
        "fr": "N2O"
    },
    {
        "key": "NH3",
        "group": "SubstanceID",
        "en": "NH3",
        "fr": "NH3"
    },
    {
        "key": "VOC",
        "group": "SubstanceID",
        "en": "VOC",
        "fr": "COV"
    },
    {
        "key": "PM10",
        "group": "SubstanceID",
        "en": "PM10",
        "fr": "MP10"
    },
    {
        "key": "PM25",
        "group": "SubstanceID",
        "en": "PM2.5",
        "fr": "MP2,5"
    },
    {
        "key": "SOx",
        "group": "SubstanceID",
        "en": "SOx",
        "fr": "SOx"
    },
    {
        "key": "THC",
        "group": "SubstanceID",
        "en": "THC",
        "fr": "HCt"
    },
    {
        "key": "CAC",
        "group": "SubstanceGroup",
        "en": "CAC",
        "fr": "PCA"
    },
    {
        "key": "GHG",
        "group": "SubstanceGroup",
        "en": "GHG",
        "fr": "GES"
    },
    {
        "key": "GEN",
        "group": "SubstanceGroup",
        "en": "GEN",
        "fr": "GÉN"
    },
    {
        "key": "Boil",
        "group": "AdminEquip",
        "en": "Boiler",
        "fr": "Chaudière"
    },
    {
        "key": "Elec",
        "group": "AdminEquip",
        "en": "General admin electricity",
        "fr": "Électricité - admin générale"
    },
    {
        "key": "Gen",
        "group": "AdminEquip",
        "en": "Generator",
        "fr": "Génératrice"
    },
    {
        "key": "Acomp",
        "group": "CHEEquip",
        "en": "Air compressors",
        "fr": "Compresseurs d'air"
    },
    {
        "key": "ACref",
        "group": "CHEEquip",
        "en": "AC\\Refrigeration",
        "fr": "Climatiseurs\\Réfrigération"
    },
    {
        "key": "Alift",
        "group": "CHEEquip",
        "en": "Aerial Lifts",
        "fr": "Chariots élévateurs - aerial lifts"
    },
    {
        "key": "BoilT",
        "group": "CHEEquip",
        "en": "Boilers - Material Transfer",
        "fr": "Chaudières - Transfert de matière"
    },
    {
        "key": "Conv",
        "group": "CHEEquip",
        "en": "Conveyors",
        "fr": "Convoyeurs"
    },
    {
        "key": "C-Oth",
        "group": "CHEEquip",
        "en": "Cranes - other",
        "fr": "Grues - autres"
    },
    {
        "key": "Crane",
        "group": "CHEEquip",
        "en": "Cranes (not RTG)",
        "fr": "Grues (pas RTG)"
    },
    {
        "key": "Craw",
        "group": "CHEEquip",
        "en": "Crawler Tractor/Dozers",
        "fr": "Tracteurs à chenilles/bouteurs"
    },
    {
        "key": "C-RMG",
        "group": "CHEEquip",
        "en": "Cranes - rail mounted gantry (RMG)",
        "fr": "Grues - à portique sur rail (RMG)"
    },
    {
        "key": "C-RTG",
        "group": "CHEEquip",
        "en": "Cranes - rubber tire gantry (RTG)",
        "fr": "Grues - à portique de manœuvre sur pneus (RTG)"
    },
    {
        "key": "Crush",
        "group": "CHEEquip",
        "en": "Crushers/grinders",
        "fr": "Concasseurs/broyeurs"
    },
    {
        "key": "Cstak",
        "group": "CHEEquip",
        "en": "Chassis Stackers",
        "fr": "Châssis empileurs"
    },
    {
        "key": "C-STS",
        "group": "CHEEquip",
        "en": "Cranes - ship to shore",
        "fr": "Ponts roulants STS (ship-to-shore)"
    },
    {
        "key": "Elec",
        "group": "CHEEquip",
        "en": "Electrical Equipment (General, Not Generators)",
        "fr": "Équipement électrique (général, pas de génératrices)"
    },
    {
        "key": "Estak",
        "group": "CHEEquip",
        "en": "Reach Stackers",
        "fr": "Empileurs"
    },
    {
        "key": "Excav",
        "group": "CHEEquip",
        "en": "Excavators (normal/adapted for logs)",
        "fr": "Excavatrices (normales/adaptées pour les bûches)"
    },
    {
        "key": "Felle",
        "group": "CHEEquip",
        "en": "Feller/Bunchers",
        "fr": "Abatteuses-empileuses"
    },
    {
        "key": "Fork",
        "group": "CHEEquip",
        "en": "Forklifts",
        "fr": "Chariots élévateurs"
    },
    {
        "key": "Gcomp",
        "group": "CHEEquip",
        "en": "Gas Compressors",
        "fr": "Compresseurs de gaz"
    },
    {
        "key": "GenSt",
        "group": "CHEEquip",
        "en": "Generator Sets",
        "fr": "Groupes électrogènes"
    },
    {
        "key": "PumpT",
        "group": "CHEEquip",
        "en": "Pumps - Transfer",
        "fr": "Pompes - transfert"
    },
    {
        "key": "PumpW",
        "group": "CHEEquip",
        "en": "Pumps - Water",
        "fr": "Pompes - eau"
    },
    {
        "key": "Pwash",
        "group": "CHEEquip",
        "en": "Pressure Washers",
        "fr": "Laveuses à pression"
    },
    {
        "key": "Rload",
        "group": "CHEEquip",
        "en": "Rubber-Tire Loaders",
        "fr": "Chargeurs à pneus en caoutchouc"
    },
    {
        "key": "Rolle",
        "group": "CHEEquip",
        "en": "Roller/compactors",
        "fr": "Rouleaux/compacteurs"
    },
    {
        "key": "RTG",
        "group": "CHEEquip",
        "en": "Rubber Tire Gantry (RTG) cranes",
        "fr": "Grues à portique avec pneus en caoutchouc (RTG)"
    },
    {
        "key": "Sbrd",
        "group": "CHEEquip",
        "en": "Signal Boards/Light Plants",
        "fr": "Panneaux de signalisation/installations lumineuses"
    },
    {
        "key": "Sload",
        "group": "CHEEquip",
        "en": "Skid Steer Loaders (small loaders)",
        "fr": "Chargeurs à direction à glissement (petits chargeurs)"
    },
    {
        "key": "Sweep",
        "group": "CHEEquip",
        "en": "Sweepers/Scrubbers",
        "fr": "Balayeuses/brosseuses"
    },
    {
        "key": "Tpick",
        "group": "CHEEquip",
        "en": "Top or Side Picks Chassis or Reach Stackers",
        "fr": "Châssis à pioches latérale ou dessus ou gerbeurs"
    },
    {
        "key": "Trac",
        "group": "CHEEquip",
        "en": "Tractors/Loaders/Backhoes",
        "fr": "Tracteurs/chargeuses/pelles rétrocaveuses"
    },
    {
        "key": "Truck",
        "group": "CHEEquip",
        "en": "Off-Hwy Truck (Not registered for on-road use)",
        "fr": "Camions hors route (pas enregistrés comme véhicules routiers)"
    },
    {
        "key": "Weld",
        "group": "CHEEquip",
        "en": "Welders",
        "fr": "Machines à souder"
    },
    {
        "key": "Yard",
        "group": "CHEEquip",
        "en": "Yard trucks (Hostler, Goats, Terminal Tractors)",
        "fr": "Camions de triage (tracteurs de manœuvre, de terminal)"
    },
    {
        "key": "Emuls",
        "group": "RetroFit",
        "en": "Diesel/water emulsion",
        "fr": "Diesel/émulsion d'eau"
    },
    {
        "key": "None",
        "group": "RetroFit",
        "en": "None",
        "fr": "Aucun"
    },
    {
        "key": "Ocert",
        "group": "RetroFit",
        "en": "On-road certified engine",
        "fr": "Moteur certifié pour la route"
    },
    {
        "key": "Ortu",
        "group": "RetroFit",
        "en": "On-road technology upgrade",
        "fr": "Amélioration à la technologie de route"
    },
    {
        "key": "OxCat",
        "group": "RetroFit",
        "en": "Diesel oxidation catalyst (DOC)",
        "fr": "Catalyseur à oxydation diesel (DOC)"
    },
    {
        "key": "Pfilt",
        "group": "RetroFit",
        "en": "Diesel particulate filter (DPF)",
        "fr": "Filtre à particules (DPF)"
    },
    {
        "key": "ReCat",
        "group": "RetroFit",
        "en": "Selective catalytic reduction (SCR)",
        "fr": "Réduction catalytique sélective (SCR)"
    },
    {
        "key": "B100",
        "group": "fuelID",
        "en": "B100 (100% biodiesel)",
        "fr": "B100 (100% biodiesel)"
    },
    {
        "key": "BBL",
        "group": "fuelID",
        "en": "Biodiesel blend",
        "fr": "Mélange biodiesel"
    },
    {
        "key": "Dies",
        "group": "fuelID",
        "en": "Diesel",
        "fr": "Diesel"
    },
    {
        "key": "E100",
        "group": "fuelID",
        "en": "E100 (100% ethanol)",
        "fr": "E100 (100% éthanol)"
    },
    {
        "key": "EBL",
        "group": "fuelID",
        "en": "Gasoline/ethanol blend",
        "fr": "Essence/mélange éthanol"
    },
    {
        "key": "Elec",
        "group": "fuelID",
        "en": "Electricity",
        "fr": "Électricité"
    },
    {
        "key": "Gas",
        "group": "fuelID",
        "en": "Gasoline",
        "fr": "Essence"
    },
    {
        "key": "Gas2",
        "group": "fuelID",
        "en": "2-Stroke Mix Gasoline",
        "fr": "Mélange essence pour moteur à deux temps"
    },
    {
        "key": "HFO",
        "group": "fuelID",
        "en": "Heavy fuel oil (HFO)",
        "fr": "Mazout lourd"
    },
    {
        "key": "HOIL",
        "group": "fuelID",
        "en": "Heating oil",
        "fr": "Mazout de chauffage"
    },
    {
        "key": "LNG",
        "group": "fuelID",
        "en": "Liquefied natural gas (LNG)",
        "fr": "Gaz naturel liquéfié (GNL)"
    },
    {
        "key": "MDO",
        "group": "fuelID",
        "en": "Marine diesel oil (MDO)",
        "fr": "Mazout marin"
    },
    {
        "key": "MGO",
        "group": "fuelID",
        "en": "Marine gas oil (MGO)",
        "fr": "Gaz-navire"
    },
    {
        "key": "NatG",
        "group": "fuelID",
        "en": "Natural Gas",
        "fr": "Gaz naturel"
    },
    {
        "key": "Prop",
        "group": "fuelID",
        "en": "Propane (LPG)",
        "fr": "Propane (GPL)"
    },
    {
        "key": "Metals",
        "group": "SubstanceID",
        "en": "Metals",
        "fr": "Métaux"
    },
    {
        "key": "Bus",
        "group": "MOBFleet",
        "en": "Transit bus",
        "fr": "Autobus urbain"
    },
    {
        "key": "Car",
        "group": "MOBFleet",
        "en": "Passenger car",
        "fr": "Voiture de tourisme"
    },
    {
        "key": "H-Car",
        "group": "MOBFleet",
        "en": "Hybrid passenger car",
        "fr": "Voiture de tourisme hybride"
    },
    {
        "key": "HDV",
        "group": "MOBFleet",
        "en": "Combination truck (tractor-trailer)",
        "fr": "Camion semi-remorque"
    },
    {
        "key": "H-LDV",
        "group": "MOBFleet",
        "en": "Hybrid light commercial truck",
        "fr": "Camion utilitaire léger hybride"
    },
    {
        "key": "H-Tru",
        "group": "MOBFleet",
        "en": "Hybrid passenger truck",
        "fr": "Camion léger hybride"
    },
    {
        "key": "LDV",
        "group": "MOBFleet",
        "en": "Light commercial truck",
        "fr": "Camion utilitaire léger"
    },
    {
        "key": "MDV",
        "group": "MOBFleet",
        "en": "Single unit truck",
        "fr": "Camion non articulé"
    },
    {
        "key": "Truck",
        "group": "MOBFleet",
        "en": "Passenger truck",
        "fr": "Camion léger"
    },
    {
        "key": "Avg",
        "group": "MOBIntensity",
        "en": "3 - Medium (average)",
        "fr": "3 - Moyenne"
    },
    {
        "key": "Havg",
        "group": "MOBIntensity",
        "en": "4 - Medium/high",
        "fr": "4 - Moyenne/élevée"
    },
    {
        "key": "Hvy",
        "group": "MOBIntensity",
        "en": "5 - High",
        "fr": "5 - Élevée"
    },
    {
        "key": "Lavg",
        "group": "MOBIntensity",
        "en": "2 - Low/medium",
        "fr": "2 - Faible/moyene"
    },
    {
        "key": "Light",
        "group": "MOBIntensity",
        "en": "1 - Low",
        "fr": "1 - Faible"
    },
    {
        "key": "NULL",
        "group": "MOBIntensity",
        "en": "No usage",
        "fr": "Pas d’usage"
    },
    {
        "key": "gen2",
        "group": "RailModel",
        "en": "Genset - 2 Eng",
        "fr": "Groupe électrogène à 2 moteurs"
    },
    {
        "key": "gen3",
        "group": "RailModel",
        "en": "Genset - 3 Eng",
        "fr": "Groupe électrogène à 3 moteurs"
    },
    {
        "key": "line",
        "group": "RailModel",
        "en": "Conventional line haul",
        "fr": "Transport ferroviaire classique"
    },
    {
        "key": "lines",
        "group": "RailModel",
        "en": "Conventional line haul - small",
        "fr": "Transport ferroviaire classique - petit"
    },
    {
        "key": "other",
        "group": "RailModel",
        "en": "Other",
        "fr": "Autre"
    },
    {
        "key": "rcp",
        "group": "RailModel",
        "en": "Rail car pusher (e.g., Rail King)",
        "fr": "Locomotive de renfort (p. ex., Rail King)"
    },
    {
        "key": "swit",
        "group": "RailModel",
        "en": "Conventional switch",
        "fr": "Locomotive de manoeuvres classique"
    },
    {
        "key": "Type_RAIL_Model",
        "group": "tableDesc",
        "en": "Defines Locomotive Type.",
        "fr": "Définit le type de locomotive."
    },
    {
        "key": "ADMIN_Link_EmisFactors",
        "group": "tableDesc",
        "en": "Fuel properties for various fuel types that are used in the ADMIN module. Diesel, Natural Gas, and Propane emission factors are sourced from the 'CHE_Link_EmisFactors' table while Electricity emission factors are sourced from the 'GEN_Link_Egrid' table.",
        "fr": "Propriétés du carburant pour divers types de carburant utilisés dans le module ADMIN. Les coefficients d’émission pour le diesel, le gaz naturel et le propane proviennent du tableau « CHE_Link_EmisFactors », tandis que les coefficients d’émission pour l’électricité proviennent du tableau « GEN_Link_Egrid »."
    },
    {
        "key": "CHE_Link_EmisFactors",
        "group": "tableDesc",
        "en": "Expansive table of CHE emission rates by equipment year, engine size and fuel type. Developed from US EPA MOVES model.",
        "fr": "Tableau exhaustif des taux d’émission de l’EMF par année-équipement, taille du moteur et type de carburant. Élaboré à partir du modèle MOVES de l’EPA des États-Unis."
    },
    {
        "key": "GEN_Link_BioGHG_EmisFactors",
        "group": "tableDesc",
        "en": "GHG intensity values (g/kWh for CO2, CH4 and N2O) for biofuel use. Values are included for all available source groups and biofuel types.",
        "fr": "Valeurs d’intensité des émissions de GES (g/kWh pour le CO2, le CH4 et le N2O) pour la consommation de biocarburant. Les valeurs sont présentées pour tous les groupes sources et types de biocarburant disponibles."
    },
    {
        "key": "GEN_Link_Biofuel_RegionFactors",
        "group": "tableDesc",
        "en": "Fraction of biofuel for all available fuel types. Values are included for each fuel type, inventory year, and region.",
        "fr": "Fraction de biocarburant pour tous les types de carburant disponibles. Les valeurs sont présentées pour chaque type de carburant, année d’inventaire et région."
    },
    {
        "key": "GEN_Link_Egrid",
        "group": "tableDesc",
        "en": "GHG intensity values (g/kWh for CO2, CH4 and N2O) for electricity use. Values are included for all Canadian provinces. The ‘Other’ region category can be used for regions outside of Canada if associated values are entered to this table.",
        "fr": "Valeurs d’intensité des émissions de GES (g/kWh pour le CO2, le CH4 et le N2O) pour la consommation d’électricité. Les valeurs sont présentées pour toutes les provinces canadiennes. La catégorie de région « Autre » peut être utilisée pour les régions situées à l’extérieur du Canada si des valeurs connexes sont saisies dans ce tableau."
    },
    {
        "key": "GEN_Link_FuelSulphur",
        "group": "tableDesc",
        "en": "Fuel sulphur content (in ppm) for all available fuel types except marine. Values are included for all available source groups, fuel types, and inventory years.",
        "fr": "Teneur en soufre du carburant (en ppm) pour tous les types de carburant disponibles, sauf le carburant marin. Les valeurs sont présentées pour tous les groupes de sources disponibles, les types de carburant et les années d’inventaire."
    },
    {
        "key": "MOB_Link_DefaultAgeProfiles",
        "group": "tableDesc",
        "en": "Default vehicle age distributions for all vehicle types. Developed from US EPA MOVES model. Conserved from previous version of PEIT.",
        "fr": "Répartition des valeurs par défaut pour l’âge des véhicules et de tous les types de véhicules. Inspiré du modèle MOVES de l’EPA des États-Unis. Conservé de la version précédente de l’OIEP."
    },
    {
        "key": "MOB_Link_EmisFactors",
        "group": "tableDesc",
        "en": "Expansive list of vehicle emission rates by vehicle year, vehicle type and fuel type. Developed from US EPA MOVES model.",
        "fr": "Liste exhaustive des taux d’émission des véhicules par année, type de véhicule et type de carburant. Élaboré à partir du modèle MOVES de l’EPA des États-Unis."
    },
    {
        "key": "RAIL_EFs",
        "group": "tableDesc",
        "en": "PM, HC, NOx, CO, NH3, and BC emission factors (in g/hp*h)",
        "fr": "Coefficients d’émission des MP, des HC, des NOx, du CO, du NH3 et du CN (en g/hp*h)."
    },
    {
        "key": "RAIL_Fuel_Index",
        "group": "tableDesc",
        "en": "Year-specific fuel intensity values (litres/net tonne kilometres) for a rail line that serves the port. Values are included for the Canadian national rail lines CN and CPKC/CP. If ‘Other’ is used as the rail service provider, associated values are entered to this table.",
        "fr": "Valeurs de l’intensité de consommation de carburant pour une année donnée (litres/tonne-kilomètre nette) pour une ligne ferroviaire desservant le port. Les valeurs sont présentées pour les lignes ferroviaires nationales CN et CPKC/CP. Si « Autre » est utilisé comme fournisseur de services ferroviaires, il faut saisir les valeurs associées dans ce tableau."
    },
    {
        "key": "RAIL_Loco_Hourly",
        "group": "tableDesc",
        "en": "Rail line locomotive hourly fuel consumption rate, for the cases where a rail line performs additional work (beyond moving trains) on terminal grounds. Values are included for Canada (typical line haul locomotive). If ‘Other’ is used as the rail service provider, associated values are entered to this table.",
        "fr": "Taux de consommation horaire de carburant des locomotives des lignes ferroviaires, pour les cas où une ligne ferroviaire effectue des travaux supplémentaires (au-delà de la circulation des trains) sur les terrains du terminal. Les valeurs sont présentées pour le Canada (locomotives de ligne générales). Si « Autre » est utilisé comme fournisseur de services ferroviaires, il faut saisir les valeurs associées dans ce tableau."
    },
    {
        "key": "RAIL_Operator",
        "group": "tableDesc",
        "en": "List of rail operators that the user can choose from.",
        "fr": "Liste des exploitants ferroviaires parmi lesquels l’utilisateur peut choisir."
    },
    {
        "key": "RAIL_Tier",
        "group": "tableDesc",
        "en": "Fraction of locomotive tier rating. Values are available for each rail operator, inventory year, and tier (0-4).",
        "fr": "Fraction du niveau de la locomotive. Les valeurs sont présentées pour chaque exploitant ferroviaire, année d’inventaire et niveau (0-4)."
    },
    {
        "key": "RAIL_Tier_Split",
        "group": "tableDesc",
        "en": "Rail line locomotive distribution by emissions tier for each rail line. Values are included for the Canadian national rail lines CN and CPKC/CP. If ‘Other’ is used as rail service provider, associated values are entered to this table.",
        "fr": "Répartition des locomotives par niveau d’émissions pour chaque ligne ferroviaire. Les valeurs sont présentées pour les lignes ferroviaires nationales CN et CPKC/CP du Canada. Si « Autre » est utilisé comme fournisseur de services ferroviaires, il faut saisir les valeurs associées dans ce tableau."
    },
    {
        "key": "RAIL_Work_Index",
        "group": "tableDesc",
        "en": "Locomotive work index value in bhp*h/US. gal. and bhp*h/L. Values available for all available locomotive types and inventory years.",
        "fr": "Valeur de l’indice de travail de la locomotive en bhp*h/gal US et en bhp*h/L. Valeurs présentées pour tous les types de locomotives disponibles et toutes les années d’inventaire."
    },
    {
        "key": "Type_ADMIN_Equip",
        "group": "tableDesc",
        "en": "Assigns the average age and average power for each of the three ADMIN equipment types (Boiler, General Admin Electricity, and Generator). The 'sccCode' is used as the last six digits in the SCC code. The first four digits are from fuel type. Emission factors for CHE are determined by combining four-digit fuel codes from 'Type_GEN_Fuel' and six digit equipment code to find equipment in the ‘CHE_Link_EmisFactors’ table.",
        "fr": "Attribue l’âge moyen et la puissance moyenne à chacun des trois types d’équipement ADMIN (chaudière, électricité - admin générale et génératrice). Le « Code SCC » est employé pour les six derniers chiffres du code SCC. Les quatre premiers chiffres appartiennent au type de carburant. Pour déterminer les coefficients d’émission pour l’EMF, il faut combiner le code du carburant à quatre chiffres du tableau « Type_GEN_Fuel » avec celui de l’équipement correspondant à six chiffres du tableau « CHE_Link_EmisFactors »."
    },
    {
        "key": "Type_CHE_Equip",
        "group": "tableDesc",
        "en": "The 'sccCode' is used as the last six digits in the SCC code. The first four digits are from fuel type. Emission factors for CHE are determined by combining four-digit fuel codes from 'Type_GEN_Fuel' and these six-digit equipment codes to find equipment in the 'CHE_Link_EmisFactors' table.",
        "fr": "La colonne « Code SCC » est employée pour les six derniers chiffres du code SCC. Les quatre premiers chiffres appartiennent au type de carburant. Pour déterminer les coefficients d’émission pour l’EMF, il faut combiner le code du carburant à quatre chiffres du tableau « Type_GEN_Fuel » avec celui de l’équipement correspondant à six chiffres du tableau « CHE_Link_EmisFactors »."
    },
    {
        "key": "Type_GEN_Fuel",
        "group": "tableDesc",
        "en": "Additional fuel/energy properties.",
        "fr": "Propriétés supplémentaires du carburant ou de l’énergie."
    },
    {
        "key": "Type_GEN_GlobalWarmingPotential",
        "group": "tableDesc",
        "en": "Various global warming potential values for CO2, CH4, and N2O.",
        "fr": "Valeurs du potentiel de réchauffement planétaire concernant le CO2, le CH4 et le N2O."
    },
    {
        "key": "Type_GEN_RegionalLocation",
        "group": "tableDesc",
        "en": "Defines Provinces and Territories.",
        "fr": "Définit les provinces et territoires."
    },
    {
        "key": "Type_GEN_Substances",
        "group": "tableDesc",
        "en": "Defines GHG's, CAC's and Air Toxics.",
        "fr": "Définit les GES, les PCA et les substances atmosphériques toxiques."
    },
    {
        "key": "Type_MOB_AgeProfile",
        "group": "tableDesc",
        "en": "Defines Age Profile (Onroad).",
        "fr": "Définit le profil d’âge."
    },
    {
        "key": "Type_MOB_Fleet",
        "group": "tableDesc",
        "en": "Sets the average speed of Facility Vehicles (used to estimate hours of operation from fuel records).",
        "fr": "Établit la vitesse moyenne des véhicules du site de l’installation (utilisée pour estimer les heures de fonctionnement à partir des registres de carburant)."
    },
    {
        "key": "Type_MOB_Intensity",
        "group": "tableDesc",
        "en": "Defines Onroad Vehicle Intensity.",
        "fr": "Définit l’intensité des émissions des véhicules routiers."
    },
    {
        "key": "Type_RAIL_Model",
        "group": "tableDesc",
        "en": "Defines Locomotive Type.",
        "fr": "Définit le type de locomotive."
    },
    {
        "key": "CommodityTypeDesc",
        "group": "terminalHint",
        "en": "Select the commodity type from the drop-down menu. If the specific commodity type such as \"Bulk Solid - Coal\" does not represent your terminal (or you handle multiple commodities), choose a general type such as \"Bulk Solid\".",
        "fr": "Sélectionner le type de marchandises parmi le menu déroulant. Si le type spécifique tel que « Vrac solide – charbon » ne représente pas votre terminal (ou vous manipulez plusieurs types de marchandises), choisir un type général tel que « Vrac solide »."
    },
    {
        "key": "AnnualThroughputDesc",
        "group": "terminalHint",
        "en": "Throughput is the measure of the total quantity of commodity handled at your terminal/facility. If your commodity type is \"Other\" then enter zero.",
        "fr": "Le débit annuel est la mesure de la quantité totale des marchandises manipulées à votre terminal ou votre installation. Si votre marchandise est de type « Autre », entrer zéro."
    },
    {
        "key": "UnitsMeasureDesc",
        "group": "terminalHint",
        "en": "Select the unit of measure from drop-down menu. If your commodity type is \"Other\" then enter zero. Confirm that the units are appropriate for the commodity type (i.e., TEU for containers).",
        "fr": "Sélectionner l'unité de mesure dans le menu déroulant. Si votre marchandise est de type « Autre », entrer zéro. Confirmer que les unités de mesure sont appropriées pour le type de marchandises (p. ex. EVP pour les conteneurs)."
    },
    {
        "key": "EnergyEquipDesc",
        "group": "adminHint",
        "en": "Select energy source from the drop-down menu first, then, select Fuel type.",
        "fr": "Sélectionnez d'abord la source d'énergie dans le menu déroulant, puis sélectionner le type de carburant."
    },
    {
        "key": "FuelTypeDesc",
        "group": "adminHint",
        "en": "Select fuel type from the drop-down menu only after selecting Energy / equipment type",
        "fr": "Sélectionner le type de carburant dans le menu déroulant uniquement après avoir sélectionné le type d'énergie ou d'équipement."
    },
    {
        "key": "TotalConsDesc",
        "group": "adminHint",
        "en": "Enter the annual energy consumption for administration. NOTE: Only include energy consumed for non-processing activities, such as offices and facility lighting. Do not include energy consumed by manufacturing operations.",
        "fr": "Indiquez la consommation annuelle d'énergie pour l'administration. REMARQUE : N'incluez que l'énergie consommée pour les activités non industrielles, telles que les bureaux et l'éclairage des installations. Ne pas inclure l'énergie consommée par les opérations de fabrication."
    },
    {
        "key": "UnitsMeasureDesc",
        "group": "adminHint",
        "en": "Select the unit of measure from the drop-down menu. Confirm that the units are appropriate for the fuel type (i.e., diesel in litres, gallons or tonnes).",
        "fr": "Sélectionnez l'unité de mesure dans le menu déroulant. Confirmez que les unités sont adaptées au type de carburant (par exemple, diesel en litres, gallons ou tonnes)."
    },
    {
        "key": "FuelTypeDesc",
        "group": "cheHint",
        "en": "Select a fuel type from drop-down menu.",
        "fr": "Sélectionnez un type de carburant dans le menu déroulant."
    },
    {
        "key": "AnnualConsDesc",
        "group": "cheHint",
        "en": "Enter the total fuel consumed only by cargo-handling equipment. For natural gas, report consumption as uncompressed gas not as CNG or LNG (only necessary if units are volumetric).",
        "fr": "Indiquer le total du carburant consommé uniquement par l'équipement de manutention de la cargaison. Pour le gaz naturel, indiquer la consommation en tant que gaz non comprimé et non en tant que GNC ou GNL (nécessaire uniquement si les unités sont volumétriques)."
    },
    {
        "key": "UnitsFuelDesc",
        "group": "cheHint",
        "en": "Select the unit of measure from drop-down menu. Ensure that the unit is appropriate for the fuel type. For natural gas, report consumption as uncompressed gas not as CNG or LNG (only necessary if units are volumetric).",
        "fr": "Sélectionnez l'unité de mesure dans le menu déroulant. Veillez à ce que l'unité soit adaptée au type de carburant. Pour le gaz naturel, indiquer la consommation en tant que gaz non comprimé et non en tant que GNC ou GNL (nécessaire uniquement si les unités sont volumétriques)."
    },
    {
        "key": "EquipTypeDesc",
        "group": "cheHint",
        "en": "Select the equipment type from the drop-down menu.",
        "fr": "Sélectionnez le type d'équipement dans le menu déroulant."
    },
    {
        "key": "ModelYearDesc",
        "group": "cheHint",
        "en": "The engine/chassis model year has be from inventory year minus 49 years to the inventory year plus one year.",
        "fr": "L'année de modèle du moteur ou du châssis doit être comprise entre l'année d'inventaire moins 49 ans et l'année d'inventaire plus un an."
    },
    {
        "key": "SimilarUnitsDesc",
        "group": "cheHint",
        "en": "List the number of units with the same age, fuel type, engine size and hours of use.",
        "fr": "Indiquez le nombre d'unités ayant le même âge, le même type de carburant, la même taille de moteur et le même nombre d'heures d'utilisation."
    },
    {
        "key": "RetrofitDesc",
        "group": "cheHint",
        "en": "Select whether the unit(s) has a retrofit from the drop-down menu. If the unit(s) has a retrofit installed, describe the retrofit manufacturer and model number in the \"Notes/comments\" column.",
        "fr": "Sélectionnez dans le menu déroulant si l'unité (les unités) est (sont) équipée(s) d'un dispositif de mise à niveau. Si l'unité est équipée d'un dispositif de modernisation, décrivez le fabricant et le numéro de modèle du dispositif dans la colonne « Notes/commentaires »."
    },
    {
        "key": "RetrofitTypeDesc",
        "group": "cheHint",
        "en": "Select a retrofit type from the drop-down menu. OPTIONAL: Select 'None' if no retrofit is installed.",
        "fr": "Sélectionnez un type d'adaptation dans le menu déroulant. OPTIONNEL : Sélectionnez « Aucun » si aucune rénovation n'est installée."
    },
    {
        "key": "FuelTypeRefDesc",
        "group": "cheHint",
        "en": "Select a fuel type from the drop-down menu. The fuel type must link to an entry in the above table.",
        "fr": "Sélectionnez un type de carburant dans le menu déroulant. Le type de carburant doit être lié à une entrée du tableau ci-haut."
    },
    {
        "key": "EngPowerDesc",
        "group": "cheHint",
        "en": "Enter the engine size of the equipment. If engine size is not available, enter manufacturer and model information under the \"Notes/comments\" column.",
        "fr": "Indiquez la taille du moteur de l'équipement. Si la taille du moteur n'est pas disponible, indiquez le fabricant et le modèle dans la colonne « Notes/commentaires »."
    },
    {
        "key": "PowerUnitsDesc",
        "group": "cheHint",
        "en": "Select the power unit for the engine of the equipment from the drop-down menu.",
        "fr": "Sélectionnez dans le menu déroulant l'unité de puissance du moteur de l'équipement."
    },
    {
        "key": "AnnualHoursDesc",
        "group": "cheHint",
        "en": "Enter the annual hours of use for one piece of equipment.",
        "fr": "Indiquez le nombre annuel d'heures d'utilisation d'un équipement."
    },
    {
        "key": "VehicleTypeDesc",
        "group": "roadHint",
        "en": "Select vehicle type from drop-down menu. Single unit trucks are medium heavy duty and larger than light commercial trucks and passenger trucks.",
        "fr": "Sélectionnez le type de véhicule dans le menu déroulant. Les camions non articulés sont des véhicules moyennement lourds et plus grands que les camions utilitaires légers et les camions légers."
    },
    {
        "key": "FuelTypeDesc",
        "group": "roadHint",
        "en": "Select the fuel type consumed by highway vehicles only from the drop-down menu.",
        "fr": "Sélectionnez dans le menu déroulant le type de carburant consommé par les véhicules routiers uniquement."
    },
    {
        "key": "AnnualGateDesc",
        "group": "roadHint",
        "en": "One gate count corresponds to a single vehicle entering then exiting the terminal/facility.",
        "fr": "Un comptage de porte correspond à un seul véhicule entrant puis sortant du terminal ou de l'installation."
    },
    {
        "key": "AvgTimeAtDesc",
        "group": "roadHint",
        "en": "Enter the average time spent by each vehicle on terminal/facility grounds in minutes. For the terminal/facility grounds definition, refer to Zone \"C\" in the \"Glossary-Glossaire\" tab in the questionnaire.",
        "fr": "Indiquer le temps moyen passé par chaque véhicule sur le terrain du terminal ou de l'installation, en minutes. Pour la définition d'un terrain de terminal ou d'installation, se référer à la zone « C » de l'onglet « Glossary-Glossaire » dans le questionnaire."
    },
    {
        "key": "AvgTimeDriveDesc",
        "group": "roadHint",
        "en": "Enter the average time spent driving by each vehicle on terminal/facility grounds in minutes.",
        "fr": "Indiquez le temps moyen passé par chaque véhicule sur le terrain du terminal ou de l'installation, en minutes."
    },
    {
        "key": "AvgTimeIdleDesc",
        "group": "roadHint",
        "en": "Enter the average time spent queueing or idling by each vehicle on terminal/facility grounds in minutes.",
        "fr": "Indiquer le temps moyen passé en file d'attente ou au ralenti par chaque véhicule dans l'enceinte du terminal ou de l'installation, en minutes."
    },
    {
        "key": "AgeProfileDesc",
        "group": "roadHint",
        "en": "Select the age profile from the drop-down menu. The age profile represents the highway vehicles that visit your facility. User-defined age profiles must be specified in the \"Custom highway vehicle age fleet profile (OPTIONAL)\" table. If the age profile is not known, select \"Average / not known\".",
        "fr": "Sélectionnez le profil d'âge dans le menu déroulant. Le profil d'âge représente les véhicules routiers qui visitent votre installation. Les profils d'âge définis par l'utilisateur doivent être spécifiés dans le tableau  « Profil personnalisé d'âge des véhicules routiers (OPTIONNEL) ». Si le profil d'âge n'est pas connu, sélectionnez « Moyen / inconnu »."
    },
    {
        "key": "DistEntryDesc",
        "group": "roadHint",
        "en": "Enter the distance from the terminal/facility to the port entrance or the first intermodal point in kilometers (km). For the port grounds definition, refer to Zone \"D\" in the \"Glossary-Glossaire\" tab in the questionnaire.",
        "fr": "Indiquez la distance entre le terminal ou l'installation et l'entrée du port ou le premier point multimodal en kilomètres (km). Pour la définition de l'enceinte portuaire, voir la zone « D » de l'onglet « Glossary-Glossaire » dans le questionnaire."
    },
    {
        "key": "DistExitDesc",
        "group": "roadHint",
        "en": "Enter the distance from the terminal/facility to the port exit or the first intermodal point in kilometers (km).",
        "fr": "Indiquer la distance entre le terminal ou l'installation et la sortie du port ou le premier point multimodal en kilomètres (km)."
    },
    {
        "key": "AvgTimeIdlePortDesc",
        "group": "roadHint",
        "en": "Enter the average time spent queuing by each vehicle on port grounds in minutes.",
        "fr": "Indiquer le temps d'attente moyen de chaque véhicule dans l'enceinte du port, en minutes."
    },
    {
        "key": "AvgSpeedPortDesc",
        "group": "roadHint",
        "en": "Enter the average speed driven by vehicles on port grounds in km/h.",
        "fr": "Indiquer la vitesse moyenne des véhicules sur le terrain du port en km/h."
    },
    {
        "key": "FuelTypeDesc",
        "group": "roadHint",
        "en": "Select the fuel type consumed by terminal/facility vehicles from the drop-down menu. Only these fuel types are accepted.",
        "fr": "Sélectionnez dans le menu déroulant le type de carburant consommé par les véhicules du terminal ou de l'installation. Seuls ces types de carburant sont acceptés."
    },
    {
        "key": "AnnualFuelConsDesc",
        "group": "roadHint",
        "en": "Enter the fuel consumed by terminal/facility vehicles only. For natural gas, report consumption as uncompressed gas not as CNG or LNG (only necessary if units are volumetric).",
        "fr": "Indiquer le carburant consommé par les véhicules du terminal ou de l'installation uniquement. Pour le gaz naturel, indiquer la consommation en tant que gaz non comprimé et non en tant que GNC ou GNL (nécessaire uniquement si les unités sont volumétriques)."
    },
    {
        "key": "UnitsFuelDesc",
        "group": "roadHint",
        "en": "Select the unit of measure from the drop-down menu. Confirm that the unit is appropriate for the fuel type. For natural gas, report consumption as uncompressed gas not as CNG or LNG (only necessary if units are volumetric).",
        "fr": "Sélectionnez l'unité de mesure dans le menu déroulant. Confirmez que l'unité est adaptée au type de carburant. Pour le gaz naturel, indiquer la consommation en tant que gaz non comprimé et non en tant que GNC ou GNL (nécessaire uniquement si les unités sont volumétriques)."
    },
    {
        "key": "VehicleTypeDesc",
        "group": "roadHint",
        "en": "Select a vehicle type from the drop-down menu.",
        "fr": "Sélectionnez un type de véhicule dans le menu déroulant."
    },
    {
        "key": "VehicleModelDesc",
        "group": "roadHint",
        "en": "The vehicle model year has be from inventory year minus 30 years to the inventory year plus one year.",
        "fr": "L'année de modèle du véhicule est comprise entre l'année d'inventaire moins 30 ans et l'année d'inventaire plus un an."
    },
    {
        "key": "SimilarVehicleDesc",
        "group": "roadHint",
        "en": "Enter the number of terminal/facility vehicles of the same type, age, fuel type and usage patterns.",
        "fr": "Indiquer le nombre de véhicules du terminal ou de l'installation de même type, âge, type de carburant et mode d'utilisation."
    },
    {
        "key": "IntensityUseDesc",
        "group": "roadHint",
        "en": "This field describes the amount of time these vehicles are used relative to other vehicles using the same fuel type. For example, if truck 1 is used 10 times more than truck 2, then enter \"high\" for truck 1 and \"low\" for truck 2.",
        "fr": "Ce champ décrit la durée d'utilisation de ces véhicules par rapport à d'autres véhicules utilisant le même type de carburant. Par exemple, si le camion 1 est utilisé 10 fois plus que le camion 2, indiquez « Élevée » pour le camion 1 et « Faible » pour le camion 2."
    },
    {
        "key": "FuelTypeRefDesc",
        "group": "roadHint",
        "en": "Select a fuel type from the drop-down menu. The fuel type must link to the table above.",
        "fr": "Sélectionnez un type de carburant dans le menu déroulant. Le type de carburant doit être lié à une entrée du tableau ci-haut."
    },
    {
        "key": "AgeProfileTitleDesc",
        "group": "roadHint",
        "en": "Please make any changes to the user-defined age profiles in the questionnaire and reupload.",
        "fr": "Veuillez apporter les modifications nécessaires aux profils d'âge définis par l'utilisateur dans le questionnaire et le téléverser à nouveau."
    },
    {
        "key": "ServiceProviderDesc",
        "group": "railHint",
        "en": "Select the rail service provider from the drop-down menu. While BNSF, CSX, UP, and NS are options, users have to enter associated data in the \"RAIL_Tier_Split\" table in the \"External Data\" tab, if not choosing CN or CPKC/CP. The values in the \"RAIL_Fuel_Index\" table may also be edited depending on provider. Users may also insert their values under 'Other' as service provider.",
        "fr": "Sélectionner un fournisseur du service dans le menu déroulant. Bien que BNSF, CSX, UP et NS soient des options, les utilisateurs doivent saisir les données associées dans le tableau « RAIL_Tier_Split » sous l'onglet « Données externes », si CN ou CPKC/CP ne sont pas sélectionnés. Les valeurs du tableau « RAIL_Fuel_Index » peuvent également être modifiées en fonction du fournisseur. Les utilisateurs peuvent également insérer leurs valeurs sous « Autre » en tant que fournisseur de services."
    },
    {
        "key": "AnnualTrainVisitsDesc",
        "group": "railHint",
        "en": "One train visit corresponds to a train entering and exiting the terminal.",
        "fr": "Une visite de train correspond à l'entrée et à la sortie d'un train dans le terminal."
    },
    {
        "key": "AvgTrainTonnageInboundDesc",
        "group": "railHint",
        "en": "Enter the net tonnage/train for trains arriving to the port. This is the total tonnage of goods carried by an average train.",
        "fr": "Indiquer le tonnage net par train pour les trains arrivant au port. Il s'agit du tonnage total de marchandises transportées par un train moyen."
    },
    {
        "key": "AvgTrainTonnageOutboundDesc",
        "group": "railHint",
        "en": "Enter the net tonnage/train for trains leaving the terminal. This is the total tonnage of goods carried by an average train.",
        "fr": "Indiquer le tonnage net par train pour les trains quittant le terminal. Il s'agit du tonnage total de marchandises transportées par un train moyen."
    },
    {
        "key": "DistPortTerminalDesc",
        "group": "railHint",
        "en": "Enter the one-way distance each train travels within the port boundary. Port boundary refers to Zone \"D\" in the \"Glossary-Glossaire\" tab in the questionnaire.",
        "fr": "Indiquez la distance aller simple parcourue par chaque train à l'intérieur de la zone portuaire. Le périmètre portuaire fait référence à la zone « D » dans l'onglet « Glossary-Glossaire » dans le questionnaire."
    },
    {
        "key": "AvgTimeTerminalDesc",
        "group": "railHint",
        "en": "Enter the total amount of time the train's locomotives spend on terminal/facility grounds doing work, per train visit. If two locomotives do work for an hour, enter 2 hours. Terminal/facility grounds refers to Zone \"C\" in the \"Glossary-Glossaire\" tab in the questionnaire.",
        "fr": "Indiquez le temps total que les locomotives du train passent à travailler sur le terrain du terminal ou de l'installation, par visite du train. Si deux locomotives travaillent pendant une heure, indiquez 2 heures. Les terrains de terminaux ou d'installations font référence à la zone « C » de l'onglet « Glossary-Glossaire » dans le questionnaire."
    },
    {
        "key": "WorkTerminalDesc",
        "group": "railHint",
        "en": "Enter the work intensity of each train (it's locomotives) on terminal/facility grounds per visit. Terminal/facility grounds refers to Zone \"C\" in the \"Glossary-Glossaire\" tab in the questionnaire.",
        "fr": "Indiquez l'intensité du travail de chaque train (ses locomotives) sur les terrains des terminaux ou d'installations par visite. Les terrains de terminaux ou d'installations font référence à la zone « C » de l'onglet « Glossary-Glossaire » dans le questionnaire."
    },
    {
        "key": "NotesDesc1",
        "group": "railHint",
        "en": "Enter supplemental information about the national/regional rail, such as the name of the regional line.",
        "fr": "Saisir des informations complémentaires sur le train national ou régional, telles que le nom de la ligne régionale."
    },
    {
        "key": "OwnershipDesc",
        "group": "railHint",
        "en": "Select the locomotive ownership from the drop-down menu.",
        "fr": "Sélectionnez le propriétaire de la locomotive dans le menu déroulant."
    },
    {
        "key": "ModelDesc",
        "group": "railHint",
        "en": "Select locomotive model from the drop-down menu. Currently, choices are limited to those identified here.",
        "fr": "Sélectionnez le modèle de locomotive dans le menu déroulant. Actuellement, les choix sont limités à ceux identifiés ici."
    },
    {
        "key": "EngineYearDesc",
        "group": "railHint",
        "en": "While all tiers are represented for most models, Genset - eng2 only has tier 2 rates and Genset - eng3 only has tier 3 rates, due to data availability. Additional genset emission rates for different tiers can be entered to the \"RAIL_EFs\" table (External Data), if needed.",
        "fr": "Bien que tous les niveaux soient représentés pour la plupart des modèles, le groupe électrogène à 2 moteurs n'a que des taux du niveau 2 et le groupe électrogène à 3 moteurs n'a que des taux du niveau 3, en raison de la disponibilité des données. Toutefois, des taux d'émission de groupes électrogènes supplémentaires peuvent être ajoutés dans le tableau « RAIL_EFs » (Données externes) au besoin."
    },
    {
        "key": "FuelTypeDesc",
        "group": "railHint",
        "en": "Select fuel type from the drop-down menu",
        "fr": "Sélectionnez le type de carburant dans le menu déroulant"
    },
    {
        "key": "AnnualFuelConsDesc",
        "group": "railHint",
        "en": "Enter the annual fuel consumption for the facility locomotives only.",
        "fr": "Indiquer la consommation annuelle de carburant pour les locomotives de l'installation uniquement."
    },
    {
        "key": "UnitsFuelDesc",
        "group": "railHint",
        "en": "Select the unit of measure from the drop-down menu. Confirm that the unit is appropriate for the fuel type (i.e., diesel in litres).",
        "fr": "Sélectionnez l'unité de mesure dans le menu déroulant. Confirmez que l'unité est adaptée au type de carburant (par exemple, diesel en litres)."
    },
    {
        "key": "NotesDesc2",
        "group": "railHint",
        "en": "Include additional details about the terminal/facility locomotives here, such as the model if not listed under the \"Model\" column.",
        "fr": "Indiquez ici des détails supplémentaires concernant les locomotives du terminal ou de l'installation, tels que le modèle s'il n'est pas mentionné dans la colonne « Modèle »."
    },
    {
        "key": "ZoneDesc",
        "group": "marineHint",
        "en": "A zone is a regional boundary that indicates where the emissions from marine vessels to be inventoried are occurring.",
        "fr": "Une zone est une limite régionale qui indique où se produisent les émissions des navires marins à inventorier."
    },
    {
        "key": "BerthAncDesc",
        "group": "marineHint",
        "en": "Only emissions from ships going to or from the selected berths/anchorages are considered when building the results.",
        "fr": "Seules les émissions des navires à destination ou en provenance des postes de mouillage ou d'amarrage sélectionnés sont prises en compte lors de l'élaboration des résultats."
    },
    {
        "key": "MarineZoneDesc",
        "group": "marineHint",
        "en": "Note that zones should be drawn as polygons to ensure accuracy of emissions.",
        "fr": "Notez que les zones doivent être dessinées sous forme de polygones pour assurer l’exactitude des émissions."
    },
    {
        "key": "MarineLatLongDesc",
        "group": "marineHint",
        "en": "Add your lattitude and longtitude coordinates in clockwise or counter clockwise direction. ",
        "fr": "Ajoutez vos coordonnées de latitude et de longitude dans le sens des aiguilles d'une montre ou dans le sens inverse des aiguilles d'une montre."
    },
    {
        "key": "MarineOnMap",
        "group": "marineHint",
        "en": "Simply click on the map to begin defining your zone. Double-click on the map to automatically save your zone",
        "fr": "Cliquez simplement sur la carte pour commencer à définir votre zone. Double-cliquez sur la carte pour enregistrer automatiquement votre zone."
    },
    {
        "key": "MarineOnMap2",
        "group": "marineHint",
        "en": "Simply click on the map to begin defining your collection of berths/anchorages. Double-click on the map to automatically save your zone",
        "fr": "Il suffit de cliquer sur la carte pour commencer à définir votre collection de postes d'amarrage/ancrages. Double-cliquez sur la carte pour enregistrer automatiquement votre zone."
    },
    {
        "key": "ShipListDesc",
        "group": "marineHint",
        "en": "Select from the list of ships to filter down the emissions. Note that the ship list changes depending on the inventory year.",
        "fr": "Sélectionnez dans la liste des navires pour filtrer les émissions. Notez que la liste des navires change en fonction de l’année d’inventaire."
    },
    {
        "key": "OutputLangDesc",
        "group": "outputHint",
        "en": "In order for the language change to be applied to the results, please recompute.",
        "fr": "Pour que le changement de langue soit appliqué aux résultats, veuillez recalculer."
    },
    {
        "key": "OutputResultsDesc",
        "group": "outputHint",
        "en": "In order to view the most updated results, please download them locally to your computer.",
        "fr": "Pour consulter les résultats les plus récents, veuillez les télécharger localement sur votre ordinateur."
    },
    {
        "key": "InvYearDesc",
        "group": "introHint",
        "en": "Note that Maritime data are only available from 2015 and up. ",
        "fr": "Notez que les données pour le transport maritime ne sont disponibles qu'à partir de 2015."
    },
    {
        "key": "PortAuthDesc",
        "group": "introHint",
        "en": "Select the port authority in which the terminal/facility operates.",
        "fr": "Sélectionnez l'administration portuaire dans laquelle le terminal ou l'installation opère. "
    },
    {
        "key": "ProvDesc",
        "group": "introHint",
        "en": "Selecting the province or territory allows the model to set fuel and energy criteria. Selecting \"All regions\" allows the model to set averaged Canadian criteria. For United Statesian ports, select 'Other' and update tables from the web interface accordingly. Marine data is only available for Canada. ",
        "fr": "La sélection de la province ou du territoire permet au modèle de définir les critères relatifs aux carburants et à l'énergie. La sélection de « Toutes les régions » permet au modèle de définir les critères canadiens moyens. Pour les ports états-uniens, sélectionnez « Autre » et mettez à jour les tableaux de l'interface web en conséquence. Les données du transport maritime ne sont disponible que pour le Canada. "
    },
    {
        "key": "GlobalWarmDesc",
        "group": "introHint",
        "en": "The highest AR is suggested, then select the global warming potential values for which this evaluation is done.\"-20\" is for a 20-year time horizon and \"-100\" is for a 100-year time horizon.",
        "fr": "L'utilisation d'AR le plus élevé est suggéré; par la suite sélectionnez les valeurs de potentiel de réchauffement planétaire pour lesquelles l'évaluation est effectuée. « -20 » correspond à un horizon de 20 ans et « -100 » correspond à un horizon de 100 ans. "
    },
    {
        "key": "terminaltitle",
        "group": "app",
        "en": "Annual commodity throughput for terminal/facility",
        "fr": "Débit annuel des marchandises pour le terminal ou l'installation"
    },
    {
        "key": "admintitle",
        "group": "app",
        "en": "Administrative energy consumption",
        "fr": "Consommation d’énergie des installations administratives"
    },
    {
        "key": "vesseltitle",
        "group": "app",
        "en": "Vessel Information",
        "fr": "Informations sur le navire"
    },
    {
        "key": "CG",
        "group": "marineEquip",
        "en": "Coast Guard",
        "fr": "Garde côtière"
    },
    {
        "key": "DS",
        "group": "marineEquip",
        "en": "DFO Fishing Surveillance Vessel",
        "fr": "MPO Navire de Surveillance des pêches"
    },
    {
        "key": "EP",
        "group": "marineEquip",
        "en": "Excursion Passenger",
        "fr": "Excursion Passager"
    },
    {
        "key": "Fish",
        "group": "marineEquip",
        "en": "Fishing",
        "fr": "Pêche"
    },
    {
        "key": "MB",
        "group": "marineEquip",
        "en": "Merchant Bulk",
        "fr": "Marchand vraquier"
    },
    {
        "key": "MC",
        "group": "marineEquip",
        "en": "Merchant Container",
        "fr": "Marchand conteneurs"
    },
    {
        "key": "MO",
        "group": "marineEquip",
        "en": "Merchant Other",
        "fr": "Marchand autre"
    },
    {
        "key": "MP",
        "group": "marineEquip",
        "en": "Merchant Passenger",
        "fr": "Marchand passagers"
    },
    {
        "key": "SP",
        "group": "marineEquip",
        "en": "Special Purpose",
        "fr": "Fonctions spéciales "
    },
    {
        "key": "TK",
        "group": "marineEquip",
        "en": "Tanker",
        "fr": "Citerne"
    },
    {
        "key": "TG",
        "group": "marineEquip",
        "en": "Tug",
        "fr": "Remorqueur"
    },
    {
        "key": "ITV",
        "group": "marineEquip",
        "en": "INNAV Test Vessel",
        "fr": "INNAV Navire Test"
    },
    {
        "key": "War",
        "group": "marineEquip",
        "en": "Warship",
        "fr": "Navire de guerre"
    },
    {
        "key": "Cruise",
        "group": "marineEquip",
        "en": "Cruise",
        "fr": "Croisière"
    },
    {
        "key": "Barge",
        "group": "marineEquip",
        "en": "Barge",
        "fr": "Barge"
    },
    {
        "key": "calcEmisErr",
        "group": "calcEmisFacErrorMsg",
        "en": "Emission factors not found for the selected equipment and fuel type pair. Try again with a different selection.",
        "fr": "Des coefficients d'émission n'ont pas été trouvés pour la paire d'équipements et de carburants sélectionnée. Réessayez avec une autre sélection."
    },
    {
        "key": "calcRoadErr",
        "group": "calcRoadError",
        "en": "There is no fuel type selected for terminal / facility vehicles. Please add them to the table and try again.",
        "fr": "Aucun type de carburant n'a été sélectionné pour les véhicules des terminaux / installations. Veuillez les ajouter au tableau et réessayer."
    },
    {
        "key": "marineZoneErr",
        "group": "marineZoneError",
        "en": "The zone shape is invalid. Please draw again.",
        "fr": "La forme de la zone n'est pas valide. Veuillez en redessiner une à nouveau."
    },
    {
        "key": "marineOtherErr",
        "group": "marineOtherError",
        "en": "For 'Other' selected under port authority, selection of berths and anchorages is required.",
        "fr": "Losrque \"Autre\" est sélectionné sous l'autorité portuaire, la sélection des postes d'amarrage et des mouillages est requise."
    },
    {
        "key": "marineQueryErr",
        "group": "marineQueryError",
        "en": "The query for the marine section is taking longer than expected to complete. Please wait a moment and try again.",
        "fr": "L'interrogation de la section marine prend plus de temps que prévu. Veuillez patienter un moment et réessayer."
    },
    {
        "key": "MEITErrRes",
        "group": "MEITErrorResult",
        "en": "Error in MEIT Database",
        "fr": "Erreur dans la base de données de l'OAIEM"
    },
    {
        "key": "FileErr",
        "group": "FileError",
        "en": "Unsupported file format",
        "fr": "Format de fichier non supporté"
    },
    {
        "key": "NoEmisErr",
        "group": "NoEmisError",
        "en": "There are no emissions to return. Please check your inventory and try again.",
        "fr": "Il n'y a pas d'émissions à retourner. Veuillez vérifier votre inventaire et réessayer."
    },
    {
        "key": "TableError1",
        "group": "TableErr1",
        "en": "Table 'MOB_Link_EmisFactors' does not have data for the inventory year.",
        "fr": "Le tableau 'MOB_Link_EmisFactors' ne contient pas de données pour l'année d'inventaire."
    },
    {
        "key": "TableError2",
        "group": "TableErr2",
        "en": "Table 'MOB_Link_DefaultAgeProfiles' does not have data for the inventory year.",
        "fr": "Le tableau  'MOB_Link_DefaultAgeProfiles' ne contient pas de données pour l'année d'inventaire."
    },
    {
        "key": "TableError3",
        "group": "TableErr3",
        "en": "Table 'GEN_Link_FuelSulphur' does not have data for the inventory year.",
        "fr": "Le tableau 'GEN_Link_FuelSulphur' ne contient pas de données pour l'année d'inventaire."
    },
    {
        "key": "TableError4",
        "group": "TableErr4",
        "en": "Table 'RAIL_Fuel_Index' does not have data for the inventory year.",
        "fr": "Le tableau 'RAIL_Fuel_Index' ne contient pas de données pour l'année d'inventaire."
    },
    {
        "key": "Commodity Type",
        "group": "terminalTitle",
        "en": "Commodity Type",
        "fr": "Type de marchandises"
    },
    {
        "key": "Annual",
        "group": "terminalTitle",
        "en": "Annual",
        "fr": "Annuelle"
    },
    {
        "key": "Notes",
        "group": "terminalTitle",
        "en": "Notes",
        "fr": "Remarques"
    },
    {
        "key": "Cancel",
        "group": "app",
        "en": "Cancel",
        "fr": "Annuler"
    },
    {
        "key": "Home",
        "group": "app",
        "en": "Home",
        "fr": "Accueil"
    },
    {
        "key": "openBracket",
        "group": "fieldError",
        "en": "\"",
        "fr": "«"
    },
    {
        "key": "closeBracket",
        "group": "fieldError",
        "en": "\"",
        "fr": "»"
    },
    {
        "key": "Property",
        "group": "fieldError",
        "en": "Property",
        "fr": "La propriété"
    },
    {
        "key": "Type",
        "group": "fieldError",
        "en": "should be of type",
        "fr": "doit être du type"
    },
    {
        "key": "Number",
        "group": "fieldError",
        "en": "number",
        "fr": "numéro"
    },
    {
        "key": "DeleteMessage",
        "group": "deleteMessage",
        "en": "Are you sure you want to delete this item?",
        "fr": "Êtes-vous certain de vouloir supprimer cet item?"
    },
    {
        "key": "Yes",
        "group": "deleteMessage",
        "en": "Yes",
        "fr": "Oui"
    },
    {
        "key": "No",
        "group": "deleteMessage",
        "en": "No",
        "fr": "Non"
    },
    {
        "key": "Error",
        "group": "errorButton",
        "en": "Error(s)",
        "fr": "Erreur(s)"
    },
    {
        "key": "CancelMessage",
        "group": "cancelMessage",
        "en": "Are you sure you want to cancel?",
        "fr": "Êtes-vous certain de vouloir annuler?"
    },
    {
        "key": "Cancel",
        "group": "cancelMessage",
        "en": "Yes",
        "fr": "Oui"
    },
    {
        "key": "OK",
        "group": "cancelMessage",
        "en": "OK",
        "fr": "Non"
    },
    {
        "key": "Required",
        "group": "errorMessage",
        "en": "Required",
        "fr": "Requis"
    },
    {
        "key": "filters",
        "group": "app",
        "en": "Filters",
        "fr": "Filtre"
    },
    {
        "key": "Tryagain",
        "group": "app",
        "en": "Try Again",
        "fr": "Réessayer"
    },
    {
        "key": "shpimport",
        "group": "app",
        "en": "Importing a shapefile requires at least the files with a .shp extension and a .dbf extension. The imported shapefile will retain only polygon features, extract the property called 'name', and must be in a geographical coordinate system.",
        "fr": "L'importation d'un fichier « shapefile » nécessite au minimum les fichiers avec une extension .shp et une extension .dbf. Le fichier « shapefile » importé conservera uniquement les entités de type polygone, extraira la propriété appelée « name » et devra être dans un système de coordonnées géographiques."
    },
    {
        "key": "tableimport1",
        "group": "app",
        "en": "To replace the default CSV file with a custom one, please follow these steps:",
        "fr": "Pour remplacer le fichier CSV par défaut par un fichier personnalisé, veuillez suivre ces étapes :"
    },
    {
        "key": "tableimport2",
        "group": "app",
        "en": "Click the \"Select File\" button below to choose your custom CSV file.",
        "fr": "Cliquez sur le bouton « Sélectionner un fichier » ci-dessous pour choisir votre fichier CSV personnalisé."
    },
    {
        "key": "tableimport3",
        "group": "app",
        "en": "After selecting the file, click the \"Upload\" button to start the upload process.",
        "fr": "Après avoir sélectionné le fichier, cliquez sur le bouton « Téléverser » pour lancer le processus de téléversement."
    },
    {
        "key": "tableimport4",
        "group": "app",
        "en": "Once the upload is complete, the custom CSV file will replace the default one.",
        "fr": "Une fois le téléversement terminé, le fichier CSV personnalisé remplacera le fichier par défaut."
    },
    {
        "key": "tableimport5",
        "group": "app",
        "en": "Note: Ensure that your custom CSV file follows the required format and contains the necessary data.",
        "fr": "Remarque : Assurez-vous que votre fichier CSV personnalisé respecte le format requis et contient les données nécessaires."
    },
    {
        "key": "alert",
        "group": "app",
        "en": "Currently, the web tool is undergoing maintenance and may not provide accurate calculations. We’re working on it and appreciate your patience.",
        "fr": "L'outil web est préssentement en cours de maintenance et peut ne pas fournir des calculs exacts. Nous y travaillons et nous vous remercions de votre patience."
    },
    {
        "key": "onmap",
        "group": "app",
        "en": "On Map",
        "fr": "Sur la carte"
    },
    {
        "key": "table",
        "group": "app",
        "en": "Table",
        "fr": "Tableau"
    }
];

export const ArrayToKeys=(array,key)=>{
    const uniqueKeys = [...new Set(array.map(o=>o[key]))];    
    return uniqueKeys.reduce((acc,uniqueKey)=>({...acc,[uniqueKey]:array.filter(o=>o[key]==uniqueKey)}),{});
};



export const keyGroupArray=ArrayToKeys(keywords,"group");
export const keyGroup=Object.keys(keyGroupArray).reduce((acc,key)=>({...acc,[key]:keyGroupArray[key].reduce((acc,o)=>({...acc,[o.key]:o}),{})}),{});
export const getKeyGroup=(lng)=>Object.keys(keyGroupArray).reduce((acc,key)=>({...acc,[key]:keyGroupArray[key].reduce((acc,o)=>({...acc,[o.key]:o[lng]}),{})}),{});
export const keyToLabel = (group,value,lng)=>(keyGroup?.[group]?.[value]?.[lng] ?? value);
export const getLabelsByGroup=(lng,key)=>keyGroupArray[key].reduce((acc,o)=>({...acc,[o.key]:o[lng]}),{});


const _findClosestMatch =(lng,input,array,field="key")=>{
  const stringArray=array.map(o=>o[lng]);
  
  const match = findClosestMatch(input,stringArray);
//   console.log("match",match,typeof input,stringArray)
  return array.find(o=>o[lng]==match)?.[field];
};

function findClosestMatch(input, stringArray) {  
  let closestMatch = null;
  let highestSimilarity = 0;

  for (const str of stringArray) {
    if(String(input)== String(str))return String(input); 
    const similarity = calculateJaccardSimilarity(String(input), String(str));    
    if (similarity >= highestSimilarity) {
      closestMatch = str;
      highestSimilarity = similarity;
    }
  }

  return closestMatch;
}

function calculateJaccardSimilarity(a, b) {
  const setA = new Set(a.toLowerCase().split(''));
  const setB = new Set(b.toLowerCase().split(''));

  const intersectionSize = new Set([...setA].filter(char => setB.has(char))).size;
  const unionSize = setA.size + setB.size - intersectionSize;

  return unionSize === 0 ? 0 : intersectionSize / unionSize;
}

const customToNumber=(value)=> {
        
        const numberValue = _.toNumber(value);
        return _.isNaN(numberValue) ? value : numberValue;
}

export const getLabelKey=(lng,key,value,optionName,field)=>{
  if(value=="Yes" || value=="Oui")return true;
  if(value=="No"|| value=="Non")return false;
  
  if(typeof value==="undefined")return value 
// console.log("keyGroupArray[optionName]",optionName,keyGroupArray[optionName])
  if(!key ||  !keyGroupArray[optionName]){
     if(typeof value==="undefined" || typeof value==="string" )return value;     
     return customToNumber(value);    
  }
//   console.log("value",value,value&&value.toString(),keyGroupArray[optionName])
    console.log("optionName",optionName,keyGroupArray[optionName])
  return _findClosestMatch(lng,value.toString(), keyGroupArray[optionName],field);
}

// const groups = [...new Set(keywords.map(o=>o.group))];
// export const keyGroupArray = groups.reduce((acc,group)=>({...acc,[group]:keywords.filter(o=>o.group==group)}),{});
// export const keyGroup = groups.reduce((acc,group)=>({...acc,[group]:keywords.filter(o=>o.group==group)}),{});


function jsonArrayToSpreadsheetData(jsonArray) {
  if (!jsonArray || !Array.isArray(jsonArray) || jsonArray.length === 0) {
    return { data: [[]]  }; // Return an empty spreadsheet data object if the input is invalid
  }
  
  const data=[];
  jsonArray.forEach((item) => {
    const row = columns.map((key) => ({ value: item[key] }));
    data.push(row);
  }); 
  return { data, columns };
}

function spreadsheetDataToJsonArray({columns,data}) {
 return data.map(item=>columns.reduce((acc,key,i)=>({...acc,[key]:item[i]?.value}),{})); 
}


export const Keywords = ({isVisible:_isVisible=true,setVisible:_setVisible,onFinish}) => {
  
  const [isVisible, setVisible] = useParentState(_isVisible,_setVisible);
  const [spreadsheetData, setSpreadsheetData] = useState([]);
  

  React.useEffect(()=>{
    const {data} = jsonArrayToSpreadsheetData(keywords);  
    setSpreadsheetData(data);  
    },[keywords]);

  const handleOk = () => {
    setVisible(false);
    const newData=spreadsheetDataToJsonArray({columns,data:spreadsheetData}).map(o=>({...o}));    
    console.log(newData);
    onFinish && onFinish(newData);    
  };

  const handleCancel = () => {
    setVisible(false);
  }; 
  const handleChange = (newData) => {   
    
    setSpreadsheetData(newData);
  };

  const addNewRow = () => {
    const newRow = [columns.map(c=>({value:''}))];
    setSpreadsheetData([...spreadsheetData, newRow]);
    
  };

  return (
   
      <MyModal        
        title="Modify keywords"
        visible={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        maskClosable={false}
        
        width={800}
      >
         
        <div style={{maxWidth: '100%',overflow: "auto"}}>
        <Spreadsheet data={spreadsheetData} columnLabels={columns} onChange={handleChange} />
         
         </div>
         <Button onClick={addNewRow}>Add Row</Button>
      </MyModal>    
  );
};
export default keywords;